const ca = {
  common: {
    photo: 'Foto',
    continue: 'Continua',
    dragToReorder: 'Arrossega per reordenar', dragToMove: 'Arrossega per moure',
    select: "Selecciona", noResults: "Sense resultats",
    save: 'Desa', cancel: 'Cancel·la', edit: 'Edita', delete: 'Elimina', add: 'Afegeix',
    back: 'Enrere', close: 'Tanca', copy: 'Copia', copied: 'Copiat!',
    loadingApp: 'Carregant Gromly',
    loading: 'Carregant…', search: 'Cerca', open: 'Obre', confirm: 'Confirma',
    enable: 'Activa', disable: 'Desactiva', create: 'Crea', invite: 'Convida',
    remove: 'Elimina', generate: 'Genera',
    fromDocument: 'Del document', fromDocumentHint: 'Importat del teu document — és la teva base fixa. L\'assistent hi construeix al voltant i no la reorganitza ni l\'elimina.',
    deleting: 'Eliminant…', required: 'Requerit', confirmDelete: 'Estàs segur? Aquesta acció no es pot desfer.',
    clear: 'Esborra', today: 'Avui',
    pickTime: 'Tria una hora', pickDate: 'Tria una data', pickDateTime: 'Tria data i hora', time: 'Hora', done: 'Fet',
    areYouSure: 'Segur?', yesDelete: 'Sí, elimina', deleteFailed: 'No s\'ha pogut eliminar',
    accept: 'Acceptar', discard: 'Descartar', ai: 'IA', or: 'o',
    error: "S'ha produït un error", saving: 'Desant…',
  },
  upload: {
    fileTooLarge: '«{{name}}» és massa gran: el límit són {{size}}',
    fileUnsupported: '«{{name}}» no és un tipus de fitxer admès',
    imageUnreadable: 'No hem pogut llegir la foto «{{name}}». Prova d’exportar-la com a JPEG.',
    storageFull: "Has arribat al límit d’espai per a fotos",
    storageFullBatch_one: "Has arribat al límit d’espai per a fotos: {{count}} foto no s’ha pujat",
    storageFullBatch_other: "Has arribat al límit d’espai per a fotos: {{count}} fotos no s’han pujat",
    progress: { title: "Pujant foto {{current}} de {{total}}", keepOpen: "No tanquis aquesta pàgina fins que acabi" },
  },
  nav: {
    myTrips: 'Els meus viatges', menu: 'Menú', docs: 'Docs', signOut: 'Tanca sessió', security: 'Seguretat', agencyHome: "Inici", collapseMenu: "Plega el menú", expandMenu: "Desplega el menú", agencyTrips: "Viatges", mode: { label: "Canvia a", personal: "Els meus viatges", admin: "Administració" }, explore: 'Explora', accountSettings: 'Configuració del compte',
    lightMode: 'Canvia a mode clar', darkMode: 'Canvia a mode fosc', language: 'Idioma',
  },
  auth: {
    unverified: {
      title: 'Verifica el teu email',
      body: "T'hem enviat un enllaç a {{email}}. Algunes accions (convidar, publicar) estan bloquejades fins que ho confirmes.",
      resend: 'Reenviar',
      resent: 'Email reenviat. Revisa la teva bústia.',
      alreadyVerified: 'El teu email ja està verificat, recarrega la pàgina.',
      resendFailed: "No s'ha pogut reenviar. Torna-ho a intentar en uns minuts.",
    },
    login: {
      heroTitle: 'Planifica cada\naventura',
      heroSubtitle: "Itineraris, reserves, despeses i les petites notes que la teva gent recordarà — guardat tot en un lloc tranquil, compartit només amb les persones que hi van.",
      heroFeatures: { flights: 'Vols', hotels: 'Hotels', places: 'Llocs', expenses: 'Despeses', checklists: 'Llistes', share: 'Comparteix' },
      heroEyebrow: 'On comença cada viatge',
      heroLine1: 'Planifica', heroLine2: "l'inoblidable,", heroLine3: "oblida't de", heroLine4: 'la resta.',
      title: 'Benvingut de nou', subtitle: 'Inicia sessió al teu compte',
      email: 'Correu electrònic', password: 'Contrasenya', submit: 'Inicia sessió',
      noAccount: 'Sense compte?', createOne: "Crea'n un",
      errorDefault: 'Correu o contrasenya incorrectes',
      googleAccount: "Aquest compte entra amb Google. Tria'l al selector de compte, o posa-li una contrasenya.",
      appleAccount: 'Aquest compte entra amb Apple. Fes servir «Continuar amb Apple», o posa-li una contrasenya.',
      setPassword: 'Posar una contrasenya a aquest compte',
      tooManyAttempts: 'Massa intents. Espera uns minuts i torna-ho a provar.',
      hidePassword: 'Amaga contrasenya', showPassword: 'Mostra contrasenya',
      breadcrumb: 'Compte · iniciar sessió',
      newHere: 'Nou per aquí?',
      createAccount: 'Crear un compte',
      continueJourney: 'Continua el teu viatge.',
      continueSubtitle: 'Inicia sessió per retornar on ho havies deixat — els teus viatges són on els vas deixar.',
      forgot: 'Oblidada?',
      passwordPlaceholder: 'Mínim 8 caràcters',
      rememberMe: 'Mantenir-me connectat en aquest dispositiu',
      orContinueWith: 'o continua amb',
      continueWithGoogle: 'Continuar amb Google',
      continueWithApple: 'Continuar amb Apple',
      footer: { privacy: 'Privadesa', terms: 'Termes', status: 'Estat', copyright: '© 2026 Gromly · Vestigi Platform, S.L.' },
    },
    forgotPassword: {
      eyebrow: 'Recuperar compte',
      title: 'Has oblidat la contrasenya?',
      subtitle: "Escriu el correu amb què et vas registrar i t'enviarem un enllaç per triar-ne una de nova.",
      emailLabel: 'Correu electrònic',
      submit: 'Enviar enllaç',
      failed: "No hem pogut enviar el correu. Torna-ho a provar d'aquí a uns minuts.",
      sentTitle: 'Mira la teva safata',
      sentBody: 'Si {{email}} té compte amb nosaltres, l\'enllaç ja és en camí.',
      sentHint: 'L\'enllaç caduca en una hora i només es pot fer servir un cop. No el trobes? Mira a correu brossa.',
      backToLogin: 'Tornar a iniciar sessió',
    },
    resetPassword: {
      eyebrow: 'Nova contrasenya',
      title: 'Tria una contrasenya nova',
      subtitle: 'Que puguis recordar: també la necessitaràs per entrar des d\'altres dispositius.',
      checking: 'Comprovant el teu enllaç…',
      newPassword: 'Nova contrasenya',
      confirmPassword: 'Repeteix la contrasenya',
      confirmPlaceholder: 'Escriu-la un altre cop',
      tooShort: 'Mínim {{min}} caràcters.',
      mismatch: 'Les dues contrasenyes no coincideixen.',
      submit: 'Canviar contrasenya',
      failed: 'No hem pogut canviar la contrasenya. Torna-ho a provar.',
      twoFactorNeeded: 'Aquest compte té verificació en dos passos. Introdueix el codi per continuar.',
      twoFactorHint: "El de la teva app d'autenticació, el mateix que fas servir per entrar.",
      invalidTitle: 'Aquest enllaç ja no serveix',
      invalidBody: 'Els enllaços caduquen en una hora i només es poden fer servir un cop. Demana\'n un de nou i el tindràs en segons.',
      requestNew: 'Demanar un enllaç nou',
      doneTitle: 'Contrasenya canviada',
      doneBody: 'Hem tancat la sessió a la resta de dispositius. Entra amb la nova contrasenya i continua on ho vas deixar.',
      goToLogin: 'Anar a iniciar sessió',
    },
    twoFactor: {
      title: 'Verificació en dos passos',
      subtitle: "Introdueix el codi de 6 dígits de la teva app d'autenticació",
      codeLabel: "Codi d'autenticació",
      verify: 'Verifica',
      back: 'Torna a l\'inici de sessió',
      invalidCode: 'Codi invàlid o caducat',
      modalTitle: 'Verificació en dos passos',
      statusEnabled: 'La 2FA està activada. El teu compte està protegit amb una app d\'autenticació.',
      statusDisabled: 'La 2FA està desactivada. Activa-la per afegir una capa extra de seguretat.',
      enable: 'Activa la 2FA',
      disable: 'Desactiva la 2FA',
      scanQr: 'Escaneja aquest codi QR amb Google Authenticator, Authy o qualsevol app TOTP.',
      manualEntry: 'O introdueix aquest secret manualment:',
      confirm: 'Activa la 2FA',
      confirmDisable: 'Desactiva la 2FA',
      disablePrompt: 'Introdueix el teu codi d\'autenticació actual per desactivar la 2FA.',
      setupError: 'No s\'ha pogut iniciar la configuració de la 2FA. Torna-ho a intentar.',
    },
    register: {
      nationality: "Nacionalitat",
      heroTitle: 'La teva propera\aventura t\'espera',
      heroSubtitle: "Crea un compte i comença a planificar\nviatges inoblidables amb la teva gent.",
      heroFeatures: ["Constructor d'itineraris dia a dia", 'Despeses compartides i deutes', 'Llocs, reserves i mapes', 'Convida companys de viatge'],
      heroEyebrow: 'La teva propera aventura comença aquí',
      heroLine1a: 'Tot gran ', heroLine1b: 'viatge', heroLine2a: 'comença amb un ', heroLine2b: 'pla.',
      heroSubheading: "Construeix itineraris, divideix despeses i guarda tots els detalls del viatge en un lloc tranquil — compartit només amb les persones que hi van.",
      title: 'Crea un compte', subtitle: 'Comença a planificar els teus viatges',
      displayName: 'Nom visible', username: 'Nickname', email: 'Correu electrònic', password: 'Contrasenya',
      passwordPlaceholder: 'Mínim 8 caràcters', submit: 'Crea el compte',
      hasAccount: 'Ja tens compte?', signIn: 'Inicia sessió',
      errorDefault: 'El registre ha fallat',
      hidePassword: 'Amaga contrasenya', showPassword: 'Mostra contrasenya',
      invitePreview: "Després de crear el teu compte t'unirem al viatge \"{{tripName}}\" de {{inviterName}}.",
      mustAcceptTerms: "Has d'acceptar els termes i la política de privadesa per continuar.",
      toastJoined: "T'has unit al viatge",
      toastInviteExpired: "Compte creat, però no hem pogut afegir-te al viatge (invitació caducada)",
      toastVerifyEmail: "T'hem enviat un email per verificar el teu compte",
      breadcrumb: 'Compte · crear',
      alreadyMember: 'Ja ets membre?',
      signInLink: 'Iniciar sessió',
      tripInviteHeader: 'Invitació de viatge',
      newAccountHeader: 'Compte nou',
      startAdventure: 'Comença la teva aventura.',
      createSubtitle: 'Crea el teu compte i comença a planificar el teu primer viatge.',
      acceptStart: 'He llegit i accepto els',
      terms: 'Termes del servei',
      and: 'i la',
      privacy: 'Política de privadesa',
      or: 'o',
      orWithEmail: 'o amb email',
    },
    verify: {
      checking: 'Verificant email…',
      success: 'Email verificat',
      failed: 'No hem pogut verificar',
      successBody: 'El teu compte està actiu. Ja pots convidar amics als teus viatges i publicar contingut.',
      failedBody: "L'enllaç no és vàlid o ha caducat. Des del teu perfil pots demanar un enllaç nou.",
      goToDashboard: 'Anar al dashboard',
      goHome: "Anar a l'inici",
    },
    completeProfile: {
      eyebrow: 'Un pas més',
      title: 'Completa el teu perfil.',
      subtitle: 'Tria un sobrenom i accepta les nostres polítiques per començar.',
      nicknameLabel: 'Sobrenom',
      nicknameHint: 'Mínim 3 caràcters. Lletres, números i guió baix.',
      acceptStart: 'He llegit i accepto els',
      terms: "Termes d'ús",
      and: 'i la',
      privacy: 'Política de privadesa',
      continue: 'Continuar',
      mustAccept: "Has d'acceptar els termes i la política de privadesa per continuar.",
      saveFailed: "No s'ha pogut desar el perfil",
    },
    callback: {
      signingIn: 'Iniciant sessió…',
    },
  },
  invite: {
    errors: {
      invalidTitle: 'Invitació no vàlida',
      invalidBody: "L'enllaç no correspon a cap invitació activa.",
      cancelledTitle: 'Invitació cancel·lada',
      cancelledBody: 'La persona que et va convidar ha cancel·lat aquesta invitació.',
      expiredTitle: 'Invitació caducada',
      expiredBody: 'Aquest enllaç ha caducat. Demana una nova invitació.',
      usedTitle: 'Invitació ja usada',
      usedBody: "Aquest enllaç ja s'ha utilitzat abans.",
      ownTitle: 'Ja ets propietari del viatge',
      ownBody: "Aquest enllaç està pensat per a una altra persona. Si vols provar com s'accepta una invitació, obre'l en una finestra d'incògnit o amb un altre compte.",
      emailMismatchTitle: "Aquesta invitació és per a un altre correu",
      emailMismatchBody: "La teva agència la va enviar a una altra adreça. Entra amb el correu que li vas donar.",
      failedTitle: 'Alguna cosa ha anat malament',
      failedBody: 'No hem pogut carregar la invitació. Torna-ho a provar.',
    },
    joined: "T'has unit al viatge",
    goDashboard: 'Tornar al dashboard',
    goHome: "Anar a l'inici",
    eyebrow: 'Invitació de viatge',
    inviterText: '{{inviterName}} et convida',
    toCollaborate: 'A col·laborar al viatge "{{tripName}}".',
    roleEditor: 'Editor',
    roleViewer: 'Només lectura',
    joining: 'Unint-te al viatge…',
    needAccount: "Per acceptar necessites un compte a Gromly. Si és la primera vegada, crea'n un en 30 segons. Si ja tens compte, entra-hi.",
    createAndJoin: 'Crear compte i unir-me',
    haveAccount: 'Ja tinc compte · iniciar sessió',
    expiresOn: 'Caduca el {{date}}',
  },
  dashboard: {
    deleteTripAria: 'Elimina el viatge',
    greeting: { morning: 'Bon dia', afternoon: 'Bona tarda', evening: 'Bona nit' },
    title: 'Les teves aventures', tagline: 'Planifica junts. Viatja millor.', searchPlaceholder: 'Cerca viatges…',
    newTrip: 'Nou viatge', newTripShort: 'Nou', addTripHint: 'Afegeix destinació, dates i viatgers',
    stats: { totalTrips: 'Total viatges', destinations: 'Destinacions', upcoming: 'Pròxims', nights: 'Nits', avgBudget: 'Pressupost mig', subPast: '{{count}} passats', subUnique: 'úniques', subTotal: 'total', subPerTrip: 'per viatge', subCredits: 'crèdits' },
    filter: { all: 'Tots', upcoming: 'Pròxims', past: 'Passats' },
    sections: { following: 'Viatges que segueixes', upcoming: 'Pròxims', past: 'Passats', horizon: "A l'horitzó", brewing: 'Viatges en preparació', alsoPlanning: 'També planificant', pastKicker: 'On has estat', pastTitle: 'Memòria', memoryLane: 'Memory lane · ja viscuts', seeAll: 'Veure els {{count}}' },
    eyebrow: { trips_one: '{{count}} viatge', trips_other: '{{count}} viatges', lived_one: '{{count}} viscut', lived_other: '{{count}} viscuts' },
    summary: { label: 'Resum', trips_one: '{{count}} viatge', trips_other: '{{count}} viatges', dests_one: '{{count}} destinació', dests_other: '{{count}} destinacions', nights_one: '{{count}} nit', nights_other: '{{count}} nits', avg: '{{amount}} mitjana', credits: '{{credits}} crèdits' },
    toast: {
      loadFailed: 'Error en carregar els viatges',
      deleted: 'Viatge eliminat',
      published: 'Viatge publicat a la comunitat!',
      unpublished: 'Viatge despublicat',
    },
    welcome: {
      title: 'Benvingut a Gromly!',
      body: "Hem creat un viatge d'exemple a Barcelona perquè puguis explorar totes les funcions. Elimina'l quan vulguis.",
      explore: 'Explorar demo →',
      create: 'Crear el meu primer viatge',
    },
    community: {
      removeTitle: 'Eliminar de la comunitat',
      shareTitle: 'Compartir viatge amb la comunitat',
      removeBody: '{{name}} deixarà de ser visible per a altres viatgers.',
      shareBody: '{{name}} es publicarà al feed de la comunitat i serà visible per a tots a Gromly.',
      remove: 'Eliminar',
      publish: 'Publicar viatge',
      shared: 'Compartit',
      share: 'Compartir',
      community: 'Comunitat',
    },
    hero: {
      onRoadNow: 'De viatge ara',
      nextAdventure: 'La teva propera aventura',
      departingIn: 'Comença en',
      day: 'dia',
      days: 'dies',
      daysLeft: 'Dies restants',
      left: 'restants',
      onRoad: 'De viatge',
      planning: 'Planificant',
      night: 'nit',
      nights: 'nits',
      openItinerary: 'Obrir itinerari',
      fieldDestination: 'Destinació',
      fieldDates: 'Dates',
      fieldTravelers: 'Viatgers',
      people_one: '{{count}} persona',
      people_other: '{{count}} persones',
    },
    card: {
      active: 'En curs',
      tomorrow: 'Demà',
      inDays_one: 'en {{count}} dia',
      inDays_other: 'en {{count}} dies',
    },
    today: 'Avui!', tomorrow: 'Demà', daysUntil: '{{count}}d', pastLabel: 'Passat',
    delete: 'Elimina', open: 'Obre',
    deleteTrip: { title: 'Eliminar aquest viatge?', body: '"{{name}}" i tot el seu itinerari, llocs, despeses i reserves s\'eliminaran permanentment.' },
    empty: {
      kicker: 'Comença aquí',
      title: 'Planifica el teu primer viatge',
      subtitle: "Crea un viatge, convida el teu company d'aventura i comença a organitzar l'itinerari, els llocs, les despeses i els checklists — tot en un lloc.",
      cta: 'Nou viatge',
      exploreCta: 'Explora viatges',
      featuresLabel: 'Funcions',
      features: [
        { label: 'Itinerari dia a dia', desc: 'Activitats, horaris i ordre' },
        { label: 'Llocs i mapa', desc: 'Desa llocs i mira la ruta' },
        { label: 'Planifica amb IA', desc: 'La IA proposa el teu viatge' },
        { label: 'Vols i hotels', desc: 'Reserves i entrades en un lloc' },
        { label: 'Despeses compartides', desc: 'Liquidació automàtica de deutes' },
        { label: 'Planifiqueu en equip', desc: 'Convida i planifiqueu junts' },
        { label: 'Llistes i maleta', desc: 'Documents i checklists de maleta' },
        { label: 'Galeria de fotos', desc: 'Els vostres records, dia a dia' },
      ],
    },
    modalTitle: 'Planifica un nou viatge',
    newTripWizard: {
      progress: "Pas {{current}} de {{total}}",
      back: "Enrere",
      stepLabel: {
        destination: "Destinació",
        dates: "Dates",
        legs: "Nits",
        travellers: "Viatgers",
        bookings: "Reserves",
        start: "Com comencem",
        documents: "Documents",
        style: "El vostre estil",
        summary: "Resum",
      },
      ask: {
        destination: "On vas?",
        dates: "Quan?",
        legs: "Quantes nits a cada lloc?",
        travellers: "Qui hi ve?",
        bookings: "Ja tens alguna reserva?",
        start: "Com vols començar?",
        documents: "Puja el que ja tinguis",
        style: "Com us agrada viatjar per {{destination}}?",
        summary: "El teu viatge està a punt",
      },
      hint: {
        destination: "Una ciutat, una regió o un país sencer. Vas a diversos llocs? Afegeix-los un a un.",
        legs: "Han de sumar les nits del viatge.",
        travellers: "Afegeix tothom qui viatja: des del primer dia podreu repartir despeses, vols i maleta.",
        bookings: "Vols, allotjament, transport o entrades, separats per tipus. Els llegim i els afegim a Docs amb el fitxer adjunt. Cada tipus gasta un crèdit d'IA.",
        start: "Després ho podràs canviar tot.",
        documents: "Reserves, bitllets o un itinerari en PDF, Word o Excel. No s'afegeix res fins que ho confirmis.",
        style: "Perquè els suggeriments s'ajustin a tu.",
        summary: "Revisa-ho i posa-li nom.",
      },
      travellersCount_one: "Només jo",
      travellersCount_other: "Som {{count}}",
      travellersFewer: "Un menys",
      travellersMore: "Un més",
      travellerDefaultName: "Viatger {{number}}",
      ticketsCount_one: "{{count}} reserva",
      ticketsCount_other: "{{count}} reserves",
      ticketsNone: "Cap",
      ticketsSkip: "Salta",
      ticketsMax: "Fins a {{count}} fitxers per tipus.",
      ticketsAddTo: "Afegeix fitxers a {{kind}}",
      travellerName: "Nom",
      travellerRemove: "Treu el viatger",
      you: "tu",
      birthDateLabel: "Data de naixement (opcional)",
      birthDateHint: "Opcional. Amb la data de naixement et podrem avisar de tarifes i avantatges per edat i ajustar millor el pla a qui viatja.",
      emailLabel: "Email",
      emailPlaceholder: "nom@email.com",
      emailHint: "Li enviarem una invitació per unir-se al viatge.",
      addEmail: "Convida per email",
      start: {
        recommended: "Recomanat",
        ai: {
          title: "Planifica'l amb IA",
          description: "Et proposem llocs, un itinerari dia a dia i consells pràctics.",
        },
        documents: {
          title: "Tinc documents",
          description: "Puja reserves o un itinerari i muntem el viatge a partir d'aquí.",
        },
        empty: {
          title: "Començo de zero",
          description: "Crea el viatge buit i omple'l al teu ritme.",
        },
      },
      documentsFound: "Això és el que hem trobat",
      complementAi: "Completa amb IA el que falti",
      complementAiHint: "Afegim llocs i itinerari al voltant del que ja cobreixen els teus documents.",
      paceLabel: "Ritme",
      budgetLabel: "Pressupost",
      interestsLabel: "Què us ve de gust?",
      notesLabel: "Alguna cosa més? (opcional)",
      generatingTitle: "Preparant el teu viatge",
      invitesFailed_one: "No s'ha pogut enviar una invitació: la pots enviar des de Participants.",
      invitesFailed_other: "No s'han pogut enviar {{count}} invitacions: les pots enviar des de Participants.",
      groupForPrompt_one: "una persona que viatja sola",
      groupForPrompt_other: "un grup de {{count}} (les edats són a la llista de viatgers)",
      destinationPlaceholder: 'Ex: Lisboa, Portugal',
      destinationAddAnother: "Afegeix una altra destinació",
      destinationRemove: "Treu {{name}}",
      legNights_one: "{{count}} nit",
      legNights_other: "{{count}} nits",
      legNightsFewer: "Una nit menys a {{name}}",
      legNightsMore: "Una nit més a {{name}}",
      legsTotal_one: "{{assigned}} de {{count}} nit",
      legsTotal_other: "{{assigned}} de {{count}} nits",
      legDays: "Dies {{from}}–{{to}}",
      legDay: "Dia {{day}}",
      legDaysShort: "dies {{from}}–{{to}}",
      legForPrompt_one: "{{name}} ({{count}} nit)",
      legForPrompt_other: "{{name}} ({{count}} nits)",
      datesPlaceholder: "Ex: del 3 al 10 d'agost, o 'la primera setmana de setembre'",
      datesParseFailed: "No he entès bé aquestes dates — pots escriure-les d'una altra manera?",
      datesPickHint: 'o tria-les al calendari de sota',
      datesAnswer_one: '{{start}} – {{end}} · {{count}} nit',
      datesAnswer_other: '{{start}} – {{end}} · {{count}} nits',
      preferencesPlaceholder: 'Ex: ritme relaxat, ens agrada la gastronomia local...',
      interestsLoading: 'Buscant què sol fer la gent aquí…',
      interestsFailed: 'No hem pogut carregar suggeriments per a aquesta destinació — pots continuar igualment.',
      pace: { relaxed: 'Relaxat', balanced: 'Equilibrat', packed: 'Intens' },
      budget: { budget: 'Econòmic', mid: 'Gamma mitjana', splurge: 'Sense límits' },
      nameLabel: 'Nom del viatge',
      currencyLabel: 'Moneda base',
      currencyHint: 'Els balanços i el pressupost es mostren en aquesta moneda; les despeses en altres monedes s’hi converteixen.',
      defaultName: 'Viatge a {{destination}}',
      next: 'Continua',
      editAnswer: 'Edita la resposta',
      importFromDocument: 'Importa des d\'un document',
      documentsRemove: "Treu els documents",
      importing: 'Llegint el teu document…',
      importFailed: 'No hem pogut llegir aquest document — prova amb un altre fitxer o continua manualment.',
      importInsufficientCredits: 'T\'has quedat sense crèdits d\'IA — pots crear el viatge manualment igualment.',
      create: 'Crear viatge', created: 'Viatge creat!', failed: 'Error en crear el viatge',
      noSpecificInterests: 'sense interessos concrets especificats',
      placesSeedPrompt: "Estem planificant un viatge de {{nights}} nits a {{destination}} amb ritme {{pace}}, per a {{travelers}}, pressupost {{budget}}. Ens interessa especialment: {{interests}}. {{notes}} Suggereix uns {{targetCount}} llocs estupends que encaixin amb això — una barreja dels interessos d'aquí dalt més un parell de bons restaurants o cafès a prop.",
      itinerarySeedPrompt: 'Organitza tots els llocs que acabes de desar en un itinerari complet dia a dia per a tot el viatge, mantenint un ritme {{pace}}.',
      tipsSeedPrompt: "Dona'm els consells més essencials i pràctics per viatjar a {{destination}} — requisits d'entrada (visat, ETA, ESTA…), vacunes recomanades o precaucions sanitàries, assegurança de viatge, i qualsevol altre consell local realment útil.",
      generating: {
        stepPlaces: 'Llocs a {{destination}}',
        stepPlacesFound_one: '{{count}} trobat',
        stepPlacesFound_other: '{{count}} trobats',
        stepItinerary_one: 'El teu itinerari d\'{{count}} nit',
        stepItinerary_other: 'El teu itinerari de {{count}} nits',
        stepItineraryDone_one: '{{count}} dia',
        stepItineraryDone_other: '{{count}} dies',
        stepTips: 'Consells pràctics per a {{destination}}',
        stepTipsDone_one: '{{count}} consell',
        stepTipsDone_other: '{{count}} consells',
        stepTickets: "Les teves reserves",
        stepTicketsDone_one: "{{count}} afegida",
        stepTicketsDone_other: "{{count}} afegides",
        ticketsUnplaced_one: "No hem pogut llegir {{count}} document: està desat a Notes perquè l'afegeixis des de Docs.",
        ticketsUnplaced_other: "No hem pogut llegir {{count}} documents: estan desats a Notes perquè els afegeixis des de Docs.",
        dayStops_one: 'Dia {{number}} · {{count}} parada',
        dayStops_other: 'Dia {{number}} · {{count}} parades',
        doneEmpty: 'Viatge creat — pots afegir llocs quan vulguis des de la pestanya Llocs.',
        errorCredits: 'Sense crèdits d\'IA — el teu viatge s\'ha creat, però no hem pogut generar suggeriments aquesta vegada.',
        errorUnknown: 'Alguna cosa ha fallat generant els suggeriments — el teu viatge s\'ha creat igualment.',
        cta: 'Veure el meu viatge',
      },
    },
  },
  birthDate: {
    day: "Dia",
    month: "Mes",
    year: "Any",
  },
  import: {
    sidebarButton: 'Importa document',
    title: 'Importa des d\'un document',
    description: 'Puja un fitxer de Word, PDF, Excel o text amb el teu pla i n\'extraurem els llocs i l\'itinerari dia a dia. No s\'afegeix res fins que ho confirmis.',
    dropHint: 'Fes clic per triar fitxers',
    addMore: 'Afegeix més fitxers',
    analyze_one: 'Analitza {{count}} document',
    analyze_other: 'Analitza {{count}} documents',
    formats: 'PDF, Word, Excel, CSV o imatges · fins a 10 fitxers',
    extracting: 'Llegint els teus documents…',
    docProgress: "Document {{current}} de {{total}}",
    reviewHint: 'Tria què afegir al teu viatge. El que ja existeix no es modifica mai.',
    savedDocsNote: 'Documents importats',
    language: {
      title: 'El document està en {{document}}',
      hint: 'El teu viatge està en {{trip}}. Tradueix el que importes perquè tot el viatge parli un sol idioma. Els noms dels llocs no es toquen.',
      action: 'Tradueix a {{trip}}',
      done: 'Contingut traduït a l\'idioma del viatge',
      failed: 'No s\'ha pogut traduir. Pots afegir-ho tal com està.',
    },
    placesSection_one: '{{count}} lloc',
    placesSection_other: '{{count}} llocs',
    daySection: 'Dia {{number}}',
    daySectionNoNumber: 'Itinerari',
    activitiesSection_one: "{{count}} activitat",
    activitiesSection_other: "{{count}} activitats",
    packingCount_one: "{{count}} objecte de maleta",
    packingCount_other: "{{count}} objectes de maleta",
    flightsSection_one: '{{count}} vol',
    flightsSection_other: '{{count}} vols',
    hotelsSection_one: '{{count}} allotjament',
    hotelsSection_other: '{{count}} allotjaments',
    nightsCount_one: '{{count}} nit',
    nightsCount_other: '{{count}} nits',
    bookingsSection_one: '{{count}} reserva',
    bookingsSection_other: '{{count}} reserves',
    tipsSection_one: '{{count}} consell',
    tipsSection_other: '{{count}} consells',
    packingSection: 'Maleta · {{section}}',
    expensesSection_one: '{{count}} despesa',
    expensesSection_other: '{{count}} despeses',
    addSelected_one: 'Afegeix {{count}} element',
    addSelected_other: 'Afegeix {{count}} elements',
    added_one: 'Afegit {{count}} element',
    added_other: 'Afegits {{count}} elements',
    mapsQuotaWarning: 'Aquesta vegada no hem pogut ubicar alguns llocs al mapa, però s\'han importat igualment.',
    errors: {
      nothingFound: 'No hem trobat cap lloc ni itinerari en aquest document.',
      extractFailed: 'No hem pogut llegir aquest document — prova amb un altre fitxer.',
      insufficientCredits: 'T\'has quedat sense crèdits d\'IA.',
      rateLimited: "Estem rebent moltes peticions ara mateix. Espera uns segons i torna-ho a provar.",
      saveFailed: 'Alguna cosa ha fallat en afegir els elements — torna-ho a provar.',
    },
  },
  trip: {
    editName: 'Fes clic per canviar el nom del viatge',
    renameFailed: 'No s’ha pogut canviar el nom del viatge',
    destinations: {
      title: "Destinacions", edit: "Canvia les destinacions",
      hint: "Els llocs que visita el viatge, en ordre, i quantes nits a cadascun.",
      saved: "Destinacions actualitzades", failed: "No s'han pogut canviar les destinacions",
      moveUp: "Puja {{name}}", moveDown: "Baixa {{name}}",
    },
    dates: {
      title: 'Dates del viatge', edit: 'Canviar les dates', confirm: 'Aplica',
      saved: 'Dates actualitzades', failed: "No s'han pogut canviar les dates",
      willMove_one: 'El viatge s’escurça. 1 parada del dia {{from}} passa al dia {{to}}.',
      willMove_other: 'El viatge s’escurça. {{count}} parades del dia {{from}} passen al dia {{to}}.',
      willLoseMeals_one: 'Es perdrà 1 àpat planificat als dies que desapareixen — els àpats se’n van amb el seu dia.',
      willLoseMeals_other: 'Es perdran {{count}} àpats planificats als dies que desapareixen — els àpats se’n van amb el seu dia.',
      willLoseOutfits_one: "Es perdrà la roba prevista d’1 dia que desapareix — continua a la maleta.",
      willLoseOutfits_other: "Es perdrà la roba prevista de {{count}} dies que desapareixen — continua a la maleta.",
      willAdd_one: 'S’afegeix un dia buit al final.', willAdd_other: 'S’afegeixen {{count}} dies buits al final.',
      noLoss_one: 'El viatge manté el seu dia, en la data nova.', noLoss_other: 'Els {{count}} dies mantenen les seves parades, en les dates noves.',
      bookingsOutside_one: '1 reserva queda fora de les dates noves', bookingsOutside_other: '{{count}} reserves queden fora de les dates noves',
      bookingsKept: 'Conserven la seva data: un localitzador és un fet, així que no es mou res per tu.',
      aFlight: 'Vol',
    },
    nav: {
      itinerary: 'Itinerari', places: 'Llocs', map: 'Mapa',
      bookings: 'Reserves', expenses: 'Despeses', meals: 'Menjars', packing: 'Maleta', info: 'Consells',
      plan: 'Pla', placesShort: 'Llocs', mapShort: 'Mapa',
      docsShort: 'Docs', money: 'Diners', mealsShort: 'Àpats', packingShort: 'Maleta', infoShort: 'Consells',
      notes: 'Notes', notesShort: 'Notes',
      services: 'Serveis', servicesShort: 'Serveis',
      gallery: 'Diari', galleryShort: 'Diari', album: 'Àlbum',
      more: 'Més',
    },
    sidebar: {
      allTrips: 'Tots els viatges', sections: 'Seccions', documentation: 'Documentació', collapse: 'Contraure barra', expand: 'Expandir barra',
      nights_one: '{{count}} nit', nights_other: '{{count}} nits',
      flights_one: '{{count}} vol', flights_other: '{{count}} vols',
      people: '{{count}} persones',
      manage: 'Gestionar',
      workspace: 'Àrea de treball',
      travellers_one: 'viatger',
      travellers_other: 'viatgers',
      underway: 'En curs',
      tomorrow: 'Demà',
      inDays: 'En {{count}} dies',
      ready: '{{pct}}% llest',
      exportPdf: 'Exportar PDF',
      generating: 'Generant…',
      exportFailed: 'Error en generar el PDF',
    },
    cover: {"title": "Foto de portada", "hint": "Surt a la targeta i la capçalera del viatge. Enquadrament 3:2.", "add": "Pujar una foto", "remove": "Tornar a la portada automàtica", "cropTitle": "Enquadra la portada", "save": "Desar la portada", "saved": "Portada actualitzada", "removed": "Torna la portada automàtica", "failed": "No s'ha pogut actualitzar la portada", "unsupported": "Aquest fitxer no és una foto que puguem fer servir", "alt": "Portada del viatge", "changeAction": "Canviar la portada"},
    contentLanguage: {
      title: 'Idioma del viatge',
      hint: "L'idioma en què l'assistent escriu el contingut del viatge: llocs, itinerari, consells i maleta. Només afecta el contingut nou; el que ja està desat es queda com està.",
      saved: 'Idioma del viatge actualitzat',
      failed: "No s'ha pogut actualitzar l'idioma del viatge",
    },
    manage: { title: 'Gestionar el viatge' },
    participants: {
      roles: { OWNER: 'Propietari', EDITOR: 'Editor', VIEWER: 'Lector' },
      title: 'Participants del viatge',
      you: '(tu)',
      pending: 'Invitacions pendents',
      invite: 'Convidar algú per email',
      sendInvitation: 'Convidar',
      hint: 'Rebrà un correu amb un enllaç per unir-s’hi. Els dos rols compten com a viatgers: comparteixen despeses i tenen la seva pròpia maleta.',
      viewerHint: 'Només el propietari del viatge pot convidar o eliminar viatgers.',
      roleEditor: 'Editor · viatja i edita',
      roleViewer: 'Només lectura · viatja, no edita',
      remove: 'Treure',
      cancelInvite: 'Cancel·lar',
      roleLabel: 'Rol: {{role}} · Caduca',
      age_one: "{{count}} any",
      age_other: "{{count}} anys",
      placeholder: {
        addBirthDate: "Afegeix la data de naixement",
        editBirthDate: "Canvia la data de naixement",
        noAccount: 'Sense compte',
        addTitle: 'Afegir algú sense compte',
        addHint: "Per a qui encara no s'ha registrat: pots posar-li despeses, vols i coses de la maleta al seu nom, i vincular-lo al seu compte més endavant.",
        namePlaceholder: 'Nom',
        add: 'Afegir',
        link: 'Vincular a un compte',
        inviteHint: "Envia-li una invitació. Quan l'accepti, tot el que és al seu nom passa al seu compte.",
        mergeHint: 'Ja és al viatge amb el seu propi compte?',
        mergeSelect: 'Tria qui és',
        merge: 'Fusionar',
        confirmMergeTitle: 'Fusionar {{name}} amb {{target}}?',
        confirmMergeBody: "Tot el que s'ha assignat a {{name}} —despeses, deutes, vols i coses de la maleta— passa a {{target}}. No es pot desfer.",
        invitationFor: 'per a {{name}}',
        toast: {
          birthDateFailed: "No s'ha pogut desar la data de naixement",
          added: "{{name}} afegit al viatge",
          addFailed: "No s'ha pogut afegir",
          merged: 'Fusionat',
          mergeFailed: "No s'ha pogut fusionar",
        },
      },
      toast: {
        invited: 'Invitació enviada',
        emailNotVerified: "Verifica el teu email abans de convidar altres usuaris",
        inviteFailed: "No s'ha pogut enviar la invitació",
        revoked: 'Invitació cancel·lada',
        revokeFailed: "No s'ha pogut cancel·lar",
        removed: 'Participant eliminat',
        roleChanged: 'Rol actualitzat',
        roleChangeFailed: "No s'ha pogut actualitzar el rol",
      },
    },
    notifications: {
      reminder_one: '{{count}} recordatori pròxim', reminder_other: '{{count}} recordatoris pròxims',
      title: 'Recordatoris',
    },
    notFound: 'Viatge no trobat',
    demo: {
      banner: "Aquest és un viatge d'exemple — explora tot el que vulguis.",
      deleteConfirm: "Eliminar aquest viatge d'exemple?",
      deleteFailed: "Error en eliminar el viatge d'exemple",
    },
    tour: {
      start: 'Fes el tour',
      skip: 'Omet',
      back: 'Enrere',
      next: 'Següent',
      finish: 'Entesos',
      steps: {
        importDoc: {
          title: "Ja tens el viatge en un document?",
          body: "Puja un Word, PDF o Excel — fins i tot tiquets de vol o hotel — i n'extraiem els llocs, l'itinerari, les reserves i les despeses.",
        },
        welcome: {
          title: 'Benvingut/da a Gromly! 👋',
          body: "Aquest és un viatge d'exemple a Barcelona. Fes un tour ràpid per veure tot el que pots fer — el pots ometre quan vulguis.",
        },
        itinerary: {
          title: 'Planifica el teu itinerari',
          body: "Organitza el viatge dia a dia: afegeix activitats, posa horaris i arrossega per reordenar.",
        },
        itineraryAi: {
          title: 'Et presentem la gIA, a tot arreu',
          body: "Ara la gIA t’acompanya a cada pantalla, acoblada aquí a la dreta. S’adapta a on siguis —itinerari, llocs, reserves, maleta o consells—, així que només cal desplegar-la per demanar-li idees, un dia sencer o que reorganitzi coses. La teva conversa et segueix quan canvies de pestanya.",
        },
        places: {
          title: 'Desa llocs per visitar',
          body: 'Reuneix restaurants, monuments i barris per categoria — i la IA pot suggerir-te nous llocs que encaixin amb el teu viatge.',
        },
        map: {
          title: 'Ho veus tot al mapa',
          body: "Els teus llocs desats i les activitats de cada dia, tot en un mateix mapa.",
        },
        mapRoutes: {
          title: 'Les rutes al mapa',
          body: 'Canvia a «Rutes» per veure tots els dies seleccionats alhora: temps de trajecte, transport per tram i «Optimitzar amb gIA» per reordenar les parades d’un dia.',
        },
        bookings: {
          title: 'Guarda les teves reserves',
          body: "Tingues vols, hotels i entrades en un sol lloc. Enganxa una confirmació i la IA n'extreu les dades per tu.",
        },
        expenses: {
          title: 'Controla i divideix despeses',
          body: 'Apunta el que gastes, marca un pressupost i divideix despeses amb els companys de viatge.',
        },
        balances: {
          title: 'Qui deu a qui',
          body: 'Gromly compensa totes les despeses compartides i et diu exactament qui deu a qui — sense càlculs.',
        },
        packing: {
          title: 'Maleta',
          body: "Llistes d'equipatge i documents per no oblidar-te de res — la IA pot generar-te la llista segons el teu destí i dates.",
        },
        tips: {
          title: 'Consells',
          body: 'Consells locals de transport, menjar i seguretat — la IA pot generar-los a mida per al teu destí.',
        },
        notes: {
          title: 'Notes',
          body: "Un bloc compartit per a idees, enllaços i qualsevol cosa que vulguis recordar.",
        },
        gallery: {
          title: 'Galeria',
          body: 'Puja les fotos del viatge i mira-les organitzades per dia.',
        },
        finish: {
          title: 'Tot a punt!',
          body: "Aquest és el tour. Explora sense por — aquest viatge d'exemple és teu per practicar, i el pots eliminar quan vulguis començar a planificar de debò.",
        },
      },
    },
    share: {
      disable: 'Desactiva el compartir', enable: 'Activa el compartir', creating: 'Creant…',
      disabledToast: 'Compartir desactivat', enabledToast: "Enllaç de compartir creat!",
      panelTitle: 'Ensenyar el viatge a qui no hi va',
      panelHint: 'Un enllaç que obre el viatge sense necessitat de compte. Qui l’obre no és un viatger: no entra a la divisió per persona, no té maleta i no compta al nombre de viatgers. Tria què es veu.',
      sectionsTitle: 'Què ensenya l’enllaç',
      sectionsHint: 'Aquest enllaç es va crear abans que existissin aquestes opcions, així que segueix ensenyant el de sempre. Marca el que vulguis afegir.',
      photosWarning: 'Els enllaços de les fotos segueixen funcionant un cop copiats, encara que ho tornis a desactivar.',
      diaryHint: "Cada autor decideix quines entrades surten. Els seguidors s'apunten per correu des de l'enllaç. Apagar l'enllaç els esborra tots.",
      section: {
        ITINERARY: 'Itinerari',
        NOTES: 'Notes de parades i llocs',
        PLACES: 'Llocs desats',
        MAP: 'Mapa',
        MEALS: 'Àpats',
        TIPS: 'Consells',
        PHOTOS: 'Fotos',
        DIARY: 'Diari',
        BOOKINGS: 'Vols, allotjament i reserves',
      },
    },
    story: {
      entry: 'Història d\'Instagram',
      title: 'Història d\'Instagram',
      upload: 'Puja una foto',
      background: 'Fons',
      gradient: { paper: 'Crema', ink: 'Negre' },
      framingHint: "Arrossega per moure la foto i fes servir la roda per ampliar-la",
      statDays: 'Dies', statStops: 'Parades', statDistance: 'Distància',
      download: 'Baixa', share: 'Comparteix',
      hint: 'Desa la imatge i puja-la a la teva història — 1080 × 1920.',
      previewAlt: 'Vista prèvia de la història',
      imageFailed: 'No s\'ha pogut carregar aquesta imatge', exportFailed: 'No s\'ha pogut crear la imatge',
    },
  },
  linkedDelete: { both: "Esborrar-ho tot" },
  itinerary: {
    stopPhotos_one: "{{count}} foto d'aquesta parada", stopPhotos_other: "{{count}} fotos d'aquesta parada",
    // ADR-0039: a stop of the travellers' own, as agency staff see it.
    maskedStop: {
      title: "Pla dels viatgers",
      hint: "És seu: l'agència no veu què és.",
    },
    deleteLinked: {
      title_one: "Aquesta parada és un àpat planificat",
      title_other: "{{count}} d'aquestes parades són àpats planificats",
      body_one: "Vols esborrar també l'àpat de Menjars?",
      body_other: "Vols esborrar també aquests àpats de Menjars?",
      only_one: "Només la parada",
      only_other: "Només les parades",
    },
    suggestTime: {
      use: 'usa',
      hint: 'Calculada des de la parada anterior i el trajecte entre totes dues. Prem-la per fer-la servir.',
      noTravel: 'Calculada des de la parada anterior. Encara no compta el trajecte.',
    },
    schedule: {
      from: 'des de',
      dayStart: 'El dia comença a les',
      setDayStart: 'Posa hora d’inici',
      clear: 'Torna a hores manuals',
      hint: 'Les hores surten d’aquesta, del que dura cada parada i del trajecte entre elles.',
      manual: 'Les hores d’aquest dia són les que vas escriure tu.',
      estimated: 'estimada',
      noTravel: 'Falta comptar els trajectes — calcula’ls i el dia es recol·locarà.',
      overrun: 'No hi cap abans d’aquesta hora fixa',
      locked: 'Hora fixa',
      timeMode: 'Tipus d’hora',
      modeAuto: 'Calculada',
      modeFixed: 'Fixa',
      autoHint: 'S’ajusta sola segons l’ordre, les durades i els trajectes.',
      fixedHint: 'No es mou encara que reordenis el dia.',
    },
    title: 'Itinerari',
    subtitle_one: '{{count}} dia · {{nights}} nits',
    subtitle_other: '{{count}} dies · {{nights}} nits',
    views: { list: 'Llista', timeline: 'Cronologia' },
    addDay: 'Afegeix dia',
    heading: 'El pla',
    daysPlanned_one: '{{count}} dia planificat',
    daysPlanned_other: '{{count}} dies planificats',
    legend: { hasActivities: 'Amb activitats', today: 'Avui' },
    dayLabel: 'Dia {{n}}',
    dayShort: 'D{{n}}',
    weather: {
      condition: { clear: 'Serè', fair: 'Poc ennuvolat', partlyCloudy: 'Parcialment ennuvolat', cloudy: 'Ennuvolat', fog: 'Boira', drizzle: 'Pluja fluixa', rain: 'Pluja', snow: 'Neu', thunder: 'Tempesta' },
      typicalFor: 'típic de {{month}}',
      aria: '{{condition}}, màxima {{max}}°, mínima {{min}}°',
      ariaTypical: 'Típic de {{month}}: màxima {{max}}°, mínima {{min}}°',
      at: "Mesurat a {{place}}",
      atTrip: "Mesurat a {{place}} — el destí del viatge, no una parada d'aquest dia",
      tripDestination: "destí del viatge",
      panel: {
        title: 'Hora a hora',
        subtitle: 'Com evoluciona el temps en cada dia del viatge',
        open: 'Veure hora a hora',
        noHourly: 'El pronòstic horari només arriba a uns 9 dies vista.',
        noData: 'No hi ha dades del temps per a aquest dia.',
        blocksLegend: "A més de ~3 dies vista el pronòstic només dóna quatre mesures al dia, i es mostren soltes. La corba horària completa apareix a mesura que aquests dies s'acosten.",
        beyondForecast: 'Més enllà del pronòstic',
        precip: '{{mm}} mm',
        wind: '{{kmh}} km/h',
      },
    },
    modal: { addActivity: 'Afegir activitat', editActivity: 'Editar activitat', addToItinerary: 'Afegir a l\'itinerari', addToDays: 'Afegir a {{count}} dies', dayLabel: 'Dia', addedToDay: 'Afegit al Dia {{n}}', addedToDays: 'Afegit a {{count}} dies', removedFromItinerary: 'Tret de l\'itinerari', itinerarySaved: 'Itinerari actualitzat', unassignHint: 'Desmarca un dia per treure\'l de l\'itinerari.', noDaysYet: 'Sense dies d\'itinerari.', noDaysDesc: 'Afegeix dies a la pestanya Itinerari primer.' },
    ai: { open: 'Obrir assistent IA', close: 'Tancar assistent IA' },
    activities_one: '{{count}} activitat',
    activities_other: '{{count}} activitats',
    flight: { outbound: 'Anada', return: 'Tornada' },
    fromBooking: 'Reserva',
    fromBookingHint: 'Ve d\'una reserva de la pestanya Reserves — edita la reserva i s\'actualitzen totes les nits.',
    hotel: { checkIn: 'Check-in', checkOut: 'Check-out', night: 'Nit' },
    continuesFrom: 'Continua des de',
    startFromPrev: { active: 'Inici aquí', inactive: 'Comença des d\'aquí', disable: 'Deixa de continuar des del dia anterior', lastOfPrevDay: 'Últim lloc del dia anterior' },
    optional: { badge: 'Opcional', label: 'Parada opcional', hint: 'Si el dia es complica, te la pots saltar sense problema.', mark: 'Marca com a opcional', unmark: 'Marca com a imprescindible' },
    openInMaps: 'Obre a Google Maps',
    openBooking: 'Obre l\'enllaç de reserva',
    delete: { title: 'Eliminar activitat?', ariaLabel: 'Eliminar activitat', body: 'Aquesta acció no es pot desfer.', bodyLocked: 'Aquesta activitat és el punt de partida del dia següent — en eliminar-la també es traurà d\'allà.' },
    bulk: { selected_one: '{{count}} seleccionada', selected_other: '{{count}} seleccionades', delete: 'Eliminar selecció', cancel: 'Cancel·la', select: 'Seleccionar', move: 'Mou a…', moveTo: 'Mou al dia', duplicate: 'Duplica a…', duplicateTo: 'Duplica al dia', deleting: 'Eliminant…' },
    stopCount_one: '{{count}} parada', stopCount_other: '{{count}} parades',
    legs: { calculate_one: 'Temps de trajecte ({{count}} tram)', calculate_other: 'Temps de trajecte ({{count}} trams)' },
    move: {
      dropOnDay: 'Deixa-la anar en un dia per moure-la',
      releaseOnDay: 'Deixa-la anar per moure-la al dia {{day}} · {{date}}',
      confirmTitle_one: 'Vols moure «{{title}}» al dia {{day}}?', confirmTitle_other: 'Vols moure {{count}} parades al dia {{day}}?',
      confirm: 'Mou',
      moved_one: 'Moguda al dia {{day}}', moved_other: '{{count}} parades mogudes al dia {{day}}',
      duplicated_one: 'Còpia creada', duplicated_other: '{{count}} còpies creades',
      failed: "No s'ha pogut moure", duplicateFailed: "No s'ha pogut duplicar",
      errorOrigin: 'La targeta «continua des de» segueix el dia anterior: no es pot moure sola.',
      errorStayNight: "Una nit d'allotjament no té data pròpia: canvia les dates de la reserva.",
      errorBookingCard: 'Una targeta generada per una reserva no es pot duplicar; duplica la reserva.',
    },
    form: {
      titleField: 'Títol', titlePlaceholder: 'p.ex. Dinar a l\'Alfama',
      yourTypes: 'Els teus tipus', newType: '+ Nou tipus…', newTypeName: 'Nom del tipus', newTypePlaceholder: 'p. ex. Snorkel, Tast de vins',
      type: 'Tipus',
      startTime: 'Hora d\'inici', duration: 'Durada', durationHours: 'h', durationMinutes: 'min',
      venueName: 'Nom del lloc', zone: 'Zona / Barri',
      bookingUrl: 'URL de reserva', notes: 'Notes',
      notesPlaceholder: 'Només efectiu, reservar amb antelació...',
      update: 'Actualitza', addActivity: 'Afegeix activitat', saveAndAddAnother: 'Desa i afegeix-ne una altra',
      day: 'Dia',
      dayBookingHint: 'Ve d\'una reserva — canviar el dia també mou la reserva.',
      dayStayHint: 'Una targeta per nit — canvia les dates de l\'allotjament a Reserves.',
      fromPlaces: 'Des de llocs guardats', filterPlaces: 'Filtra llocs…', noMatchPlaces: 'Sense resultats',
    },
    types: {
      RESTAURANT: 'Restaurant', CAFE: 'Cafè', MONUMENT: 'Monument', VIEWPOINT: 'Mirador',
      NEIGHBORHOOD: 'Barri', PARK: 'Parc', SHOP: 'Botiga', EXPERIENCE: 'Experiència',
      TRANSPORT: 'Transport', PARKING: 'Pàrquing', BEACH: 'Platja', NATURE: 'Natura', ACCOMMODATION: 'Allotjament', OTHER: 'Altre',
    },
    toast: {
      added: 'Activitat afegida!', addedWithPlace: 'Activitat afegida · {{name}} desat a Llocs',
      updated: 'Activitat actualitzada',
      deleted: 'Activitat eliminada', failed: 'Error en desar l\'activitat',
      loadFailed: 'Error en carregar l\'itinerari', removedSuccess: 'Activitat eliminada',
      movedToDay: 'Moguda al dia {{n}}',
      optimizeFailed: 'Error en optimitzar amb IA', optimizeNoResult: "No s'ha pogut optimitzar la ruta",
      optimizeApplied: 'Ruta optimitzada aplicada', reorderFailed: "No s'ha pogut desar el nou ordre",
    },
    undo: { action: 'Desfer', undoLabel: 'Desfer (Ctrl+Z)', redoLabel: 'Refer (Ctrl+Shift+Z)', undone: 'Desfet', failed: "No s'ha pogut desfer — s'ha recarregat el pla", reordered: 'Ordre canviat', legMode: 'Mode de transport canviat' },
    empty: {
      noDays: 'Sense dies encara',
      noDaysDesc: 'Els dies es generen automàticament des de les dates del viatge. Per afegir més dies, amplia la data de fi a la configuració del viatge.',
      clickDay: 'Fes clic en un dia del viatge per veure les activitats',
      noEvents: 'Sense esdeveniments. Afegeix dies i activitats primer.',
      noActivities: 'Encara no hi ha activitats',
      addStop: 'Afegir parada', planWithAi: 'Planificar amb gIA', fromSaved: 'Dels meus llocs guardats',
      planPrompt: 'Planifica’m el dia {{n}}: tria les parades, posa-les en un ordre sensat i dona una hora a cadascuna.',
    },
    dow: { mon: 'Dl', tue: 'Dm', wed: 'Dc', thu: 'Dj', fri: 'Dv', sat: 'Ds', sun: 'Dg' },
    dayUnit_one: 'DIA', dayUnit_other: 'DIES',
  },
  venues: {
    title: 'Llocs per visitar',
    categories: {
      RESTAURANT: 'Restaurants', CAFE: 'Cafès', ATTRACTION: 'Atraccions',
      VIEWPOINT: 'Miradors', NEIGHBORHOOD: 'Barris', PARK: 'Parcs',
      SHOP: 'Botigues', EXPERIENCE: 'Experiències', TRANSPORT_HUB: 'Transport',
      BEACH: 'Platges', NATURE: 'Natura', PARKING: 'Pàrquings', OTHER: 'Altres',
    },
    filter: { all: 'Tots', toVisit: 'Per visitar', visited: 'Visitats', day: 'Dia', scheduled: 'Amb dia', unscheduled: 'Sense dia' },
    noDaySection: 'Sense dia assignat',
    progress: '{{visited}} de {{total}} visitats',
    placesCount_one: 'LLOC', placesCount_other: 'LLOCS',
    addPlace: 'Afegir lloc', editPlace: 'Editar lloc', addToItinerary: "Afegir a l'itinerari",
    addToDay: 'Afegir al dia',
    mapView: 'Mapa', maps: 'Maps', book: 'Reservar',
    markVisited: 'Marcar com a visitat', markUnvisited: 'Desmarcar visitat', visited: 'Visitat',
    viewOnMaps: 'Veure a Google Maps',
    openNow: 'Obert ara', closedNow: 'Tancat ara', fullSchedule: 'Veure horari complet', closedDay: 'Tancat',
    hoursDisclaimer: "L'horari pot no estar 100% actualitzat — confirma-ho amb el local.",
    showDetails: 'Veure fotos i valoracions', showDetailsSource: '· via Google',
    detailsUnavailable: "No hi ha informació addicional d'aquest lloc.",
    deleted: 'Lloc eliminat',
    form: {
      name: 'Nom', category: 'Categoria', address: 'Adreça',
      priceInfo: 'Preu', bookingUrl: 'URL de reserva', notes: 'Notes',
      searchPlace: 'Cerca un lloc o adreça…',
      namePlaceholder: 'p.ex. Casa Marieta', pricePlaceholder: 'p.ex. ~20€/persona', notesPlaceholder: 'Només efectiu, reservar amb 2 setmanes…',
      customCategory: 'Tipus de lloc', customCategoryPlaceholder: 'p. ex. Cova, Celler, Aigües termals',
      yourCategories: 'Les teves categories', newCategory: '+ Nova categoria…',
    },
    bulk: { addToDay: 'Afegeix a un dia…', scheduled_one: 'Afegit al dia {{n}}', scheduled_other: '{{count}} llocs afegits al dia {{n}}' },
    noMatch: 'Cap lloc coincideix amb aquest filtre.',
    day_one: 'Dia {{days}}', day_other: 'Dies {{days}}',
    empty: { title: 'Construeix la teva llista de llocs', body: "Guarda cada restaurant, monument, cafè i mirador. Marca'ls com a visitats mentre explores i enllaça directament amb Google Maps.", addFirst: 'Afegir primer lloc', askAi: 'Demanar suggeriments a la IA' },
    delete: {
      title: 'Eliminar lloc',
      body: 'Segur que vols eliminar aquest lloc? Aquesta acció no es pot desfer.',
      confirm: 'Eliminar',
      withStops_one: 'També és una parada del dia {{days}} — aquesta parada se\'n va amb ell.',
      withStops_other: 'També és una parada dels dies {{days}} — aquestes parades se\'n van amb ell.',
    },
    toast: {
      loadFailed: 'Error en carregar els llocs',
      deleted: 'Lloc eliminat',
      added: '{{name}} afegit als teus llocs',
      addFailed: 'Error en afegir el lloc',
      updated: 'Lloc actualitzat',
      saveFailed: 'Error en desar el lloc',
      suggestionAdded_one: '{{count}} lloc nou afegit',
      suggestionAdded_other: '{{count}} llocs nous afegits',
      suggestionFailed: "No s'han pogut generar més suggeriments",
      suggestionError: 'Error en generar suggeriments',
    },
  },
  map: {
    routeError: 'No s\'ha pogut calcular la ruta', stopsCount_one: '{{count}} parada', stopsCount_other: '{{count}} parades',
    travelMode: { WALKING: 'Caminar', DRIVING: 'Cotxe', BICYCLING: 'Bici', TRANSIT: 'Transport', FERRY: 'Ferri', FLIGHT: 'Vol', TRANSFER: 'Trasllat', ferryLeg: '{{duration}} en ferri', unavailable: 'No disponible per a aquest tram', fallbackToast_one: 'Aquest mode de transport no té ruta en aquest tram — canviat a un que sí', fallbackToast_other: 'Sense ruta en aquest mode de transport en {{count}} trams — canviats a un que sí' },
    allPlaces: 'Tots els llocs',
    dayLabel: 'Dia {{n}}',
    showOnlyCategory: 'Veure només {{label}}',
    destinationChip: { showWholeTrip: 'Veure tot el viatge', showOnly: 'Veure només {{name}}' },
    removeCategoryFilter: 'Treure el filtre {{label}}',
    showAllCategories: 'Veure totes les categories',
    collapsePanel: 'Contraure el panell', expandPanel: 'Desplegar el panell',
    quota: { title: 'Límit mensual de mapes assolit', body: 'Els llocs, rutes i cerques queden en pausa fins que es renovi el límit.', bodyWithDate: 'Els llocs, rutes i cerques queden en pausa fins que es renovi el límit el {{date}}.', hint: 'La resta del viatge continua funcionant amb normalitat.' },
    unavailable: { title: 'No s’ha pogut carregar el mapa', body: 'Google Maps no ha respost. Revisa la connexió i torna-ho a provar d’aquí a una estona.' },
    dayFilter: 'Dia',
    showAll: 'Mostrar-ho tot', hideAll: 'Amagar-ho tot',
    showAllDays: "Mostrar tots els dies",
    optionalStops: 'Opcionals',
    optionalStopsHint: 'Amaga les parades opcionals. La ruta dibuixada hi segueix passant: el tram atenuat és el que t\'estalviaries saltant-te-les.',
    dayNotCalculated: "No s'ha pogut calcular la ruta d'aquest dia",
    scrollLeft: 'Desplaçar a l\'esquerra', scrollRight: 'Desplaçar a la dreta',
    searchPlaces: 'Cerca llocs…',
    legFromTo: 'Trajecte de {{from}} a {{to}}',
    calculating: 'Calculant…',
    routes: 'Rutes',
    daysCount_one: '{{count}} dia', daysCount_other: '{{count}} dies',
    noDaysSelected: 'Cap dia seleccionat',
    savedPlaces: 'Llocs desats', savedPlacesHint: 'Mostra els llocs desats que encara no són a cap ruta',
    showOnMap: 'Veure {{name}} al mapa',
    places: 'Llocs', fullRoute: 'Ruta completa',
    calculatingRoutes: 'Calculant rutes…',
    optimizing: 'Optimitzant…',
    optimizeWith: 'Optimitzar amb',
    optimize: 'Optimitzar',
    openInMaps: 'Obrir a Maps',
    recenter: 'Recentrar mapa',
    savePlaceModal: 'Guardar lloc',
    addToItineraryModal: "Afegir a l'itinerari",
    aiOptimizePrompt: "Optimitza l'ordre de les parades d'avui per minimitzar desplaçaments.",
    aiOptimizeHintPrefix: "Indicacions de l'usuari (prioritàries sobre els criteris genèrics)",
    aiHint: {
      title: 'Indicacions per a la IA',
      subtitle: 'Opcional. Indica horaris, àpats o preferències específiques.',
      placeholder: 'Ex. La Sagrada Família al matí, sopar de tapes cap a les 21h…',
    },
    center: 'Centrar', save: 'Desar',
    aiProposalTitle: 'Suggeriment de ruta IA', proposedOrder: 'Ordre proposat',
    filter: 'Filtre',
    locatingPlaces: 'Localitzant els teus llocs…', locationsToFind: 'llocs per trobar',
    noDaysYet: 'Encara no hi ha dies a l\'itinerari', addDaysFirst: 'Afegeix dies a la pestanya Itinerari primer.',
    loadError: 'Error en carregar Google Maps. Comprova l\'API key.',
    collapseStops: 'Col·lapsar parades', expandStops: 'Expandir parades', tapToSeeStops: 'Toca per veure les parades',
  },
  bookings: {
    expenses: { paid: 'Pagat per aquesta reserva', add: 'Afegir despesa' },
    types: { TRANSPORT: 'Transport', EVENT: 'Esdeveniment', ACTIVITY: 'Activitat', RESTAURANT: 'Restaurant', OTHER: 'Altre' },
    title: 'Reserves i entrades', subtitle: 'Vols, hotels, transport i entrades',
    sections: { flights: 'Vols', hotels: 'Hotels i allotjament', transport: 'Transport', events: 'Esdeveniments i entrades' },
    form: {
      direction: 'Direcció', outbound: '→ Anada', return: '← Tornada',
      from: 'Origen (IATA)', to: 'Destí (IATA)', departure: 'Sortida', arrival: 'Arribada',
      flightNumber: 'Número de vol', airline: 'Aerolínia',
      bookingRef: 'Referència de reserva', notes: 'Notes',
      hotelName: 'Nom de l\'hotel', address: 'Adreça', checkIn: 'Entrada', checkOut: 'Sortida',
      currency: 'Moneda', bookingUrl: 'URL de reserva',
      category: 'Categoria', title: 'Títol', provider: 'Proveïdor / Empresa',
      date: 'Data', startTime: 'Hora d\'inici', endTime: 'Hora de fi',
      startDate: 'Data d\'inici', endDate: 'Data de fi',
      endDateHint: 'Només si dura diversos dies',
      endDateBeforeStart: 'La data de fi és anterior a la d\'inici',
      venue: 'Lloc / Local', price: 'Preu', confirmed: 'Confirmat',
      documents: 'Documents (PDFs, imatges, correus)',
      saveChanges: 'Desa els canvis', addFlight: 'Afegeix vol', addHotel: 'Afegeix hotel', addBooking: 'Afegeix reserva',
      legs: 'Trams', addLeg: 'Afegeix tram', passengers: 'Passatgers',
      searchPlace: 'Cerca un lloc o adreça…',
      extractWithAi: 'Omple amb IA', extracting: 'Llegint document…', addWithAi: 'Afegeix amb IA',
      addWithAiTitle: 'Afegeix amb IA',
      addWithAiExplanation: "Puja un bitllet, targeta d'embarcament o confirmació de reserva (PDF, foto o el mateix correu desat com a .eml) i el llegim per tu, adjunts inclosos: dates, horaris, número de vol, referències de reserva i més s'omplen automàticament. Podràs revisar-ho tot abans de desar.",
      addWithAiDropTitle: 'Deixa el teu arxiu aquí', addWithAiDropSubtitle: 'o fes clic per cercar-lo — PDF, imatge o correu (.eml)',
      unreviewedTitle_one: 'Queda 1 vol per revisar', unreviewedTitle_other: 'Queden {{count}} vols per revisar',
      unreviewedBody_one: 'S\'ha llegit del document però encara no està desat. Si tanques ara, no s\'afegirà.',
      unreviewedBody_other: 'S\'han llegit del document però encara no estan desats. Si tanques ara, no s\'afegiran.',
      unreviewedDiscard: 'Descarta', unreviewedKeep: 'Continua revisant',
      stepIndicator: 'Pas {{current}} de {{total}}', saveAndContinue: 'Desa i continua',
      legNumber: 'Tram {{n}}', removeLeg: 'Elimina el tram', arrivalBeforeDeparture: 'arribada ≤ sortida',
      hotelNamePlaceholder: 'El Gran Hotel',
      bookingTitlePlaceholder: 'p. ex. Renfe AVE Madrid–Barcelona',
      venuePlaceholder: 'Bernabéu, Teatre Reial…',
    },
    reminder: {
      startsIn: 'Comença d\'aquí a {{delay}}', endsIn: 'Acaba d\'aquí a {{delay}}',
      endTitle: 'Fi · {{title}}',
      label: 'Recordatori abans de l\'acte', minutes: 'minuts', hours: 'hores',
      warnNoTime: 'Estableix una hora d\'inici per activar el recordatori',
    },
    docs: {
      title: 'Documents', upload: 'Puja arxiu',
      dropHere: 'Deixa un PDF, imatge o correu (.eml) aquí, o fes clic per pujar',
      attachFile: 'Adjunta tiquet, PDF, captura o correu', addMore: 'Afegeix més arxius',
      deleteTitle: 'Eliminar document?', deleteConfirm: 'Eliminar "{{name}}"? Aquesta acció no es pot desfer.',
    },
    deleteItem: {
      flightTitle: 'Eliminar vol?', hotelTitle: 'Eliminar hotel?', bookingTitle: 'Eliminar reserva?',
    },
    empty: {
      noFlights: 'Sense vols afegits', noHotels: 'Sense hotels afegits',
      noTransport: 'Afegeix trens, busos, ferris o cotxes de lloguer',
      noEvents: 'Afegeix concerts, teatre, esports, tours, restaurants…',
      addOne: 'Afegeix-ne',
    },
    notifications: {
      blocked: 'Les notificacions estan bloquejades. Activa-les a la configuració del navegador per rebre recordatoris.',
      prompt: 'Activa les notificacions del navegador per rebre recordatoris abans de les teves reserves.',
      enableBtn: 'Activa',
    },
    status: { outbound: 'Anada', return: 'Tornada', confirmed: 'Confirmat', pending: 'Pendent' },
    modal: {
      editFlight: 'Edita vol', addFlight: 'Afegeix vol',
      editHotel: 'Edita hotel', addHotel: 'Afegeix hotel',
      editBooking: 'Edita reserva', addBooking: 'Afegeix reserva',
    },
    toast: {
      loadFailed: 'Error en carregar reserves', saveFailed: 'Error en desar',
      flightDeleted: 'Vol eliminat', hotelDeleted: 'Hotel eliminat', bookingDeleted: 'Reserva eliminada',
      flightAdded: 'Vol afegit', flightUpdated: 'Vol actualitzat',
      hotelAdded: 'Hotel afegit', hotelUpdated: 'Hotel actualitzat',
      bookingAdded: 'Reserva afegida', bookingUpdated: 'Reserva actualitzada',
      fileDeleted: 'Arxiu eliminat', uploadFailed: 'Error en pujar',
      uploadFileFailed: 'No s\'ha pogut pujar {{name}}',
      filesUploaded_one: '{{count}} arxiu pujat', filesUploaded_other: '{{count}} arxius pujats',
      extractSuccess: 'Dades emplenades — revisa-les abans de desar', extractFailed: 'No s\'ha pogut llegir el document',
      extractNoMatch: 'No s\'ha pogut relacionar: {{names}}. Afegeix-los manualment.',
    },
    yourTickets: 'Els teus bitllets',
    bookingsCount_one: 'RESERVA', bookingsCount_other: 'RESERVES',
    durationDays_one: '{{count}} dia', durationDays_other: '{{count}} dies',
    view: { sections: 'Seccions', timeline: 'Cronologia' },
    timeline: { dayLabel: 'Dia {{n}}', noTickets: 'Sense bitllets', ongoingDay: 'dia {{n}}/{{total}}', ongoingEnd: 'últim dia' },
    ticket: {
      from: 'Origen', to: 'Destí', direct: 'Directe',
      layover_one: '{{count}} escala', layover_other: '{{count}} escales',
      layoverAt: 'Escala a {{airport}}',
    },
  },
  expenses: {
    reservationGroups: { FLIGHT: 'Vols', HOTEL: 'Allotjaments', BOOKING: 'Altres reserves' },
    travellersCount_one: '{{count}} VIATGER', travellersCount_other: '{{count}} VIATGERS',
    title: 'Despeses',
    ledger: 'El llibre de comptes',
    redistribute: {
      title: 'Nous membres al viatge',
      desc_one: '{{names}} s’ha unit després de registrar despeses. Vols repartir també amb ell/ella la {{count}} despesa compartida anterior?',
      desc_other: '{{names}} s’ha unit després de registrar despeses. Vols repartir també amb ell/ella les {{count}} despeses compartides anteriors?',
      apply: 'Repartir amb ells',
      dismiss: 'Ara no',
      done_one: 'S’ha repartit {{count}} despesa',
      done_other: 'S’han repartit {{count}} despeses',
      failed: 'No s’han pogut repartir les despeses',
    },
    stats: { totalSpent: 'Total gastat', expenses: 'Despeses', biggest: 'El major' },
    subtitle_one: '{{count}} registre', subtitle_other: '{{count}} registres',
    addExpense: 'Afegeix despesa', editExpense: 'Edita despesa',
    delete: { link: 'Elimina la despesa', title: 'Vols eliminar aquesta despesa?' },
    expenseCount_one: '{{count}} despesa', expenseCount_other: '{{count}} despeses',
    splits_one: '{{count}} divisió', splits_other: '{{count}} divisions',
    chart: { totalSpent: 'Total gastat', total: 'total' },
    groupBy: { all: 'Tots', byCategory: 'Per categoria' },
    scan: {
      button: 'Escanejar un tiquet',
      aiButton: 'Escanejar amb IA',
      scanning: 'Llegint…',
      success: 'Tiquet llegit — revisa les dades',
      failed: 'No s’ha pogut llegir l’arxiu. Omple’l a mà.',
      title: 'Escanejar gastos amb IA',
      explanation: 'Puja un tiquet, o una captura del teu banc o moneder amb diversos moviments — cada gasto detectat torna aquí perquè el revisis.',
      dropTitle: 'Deixa aquí un tiquet o una captura',
      dropSubtitle: 'Imatges o PDF · fins a {{count}} arxius',
      reviewHint_one: '{{count}} gasto detectat. Desmarca el que no vulguis i toca una fila per editar-la.',
      reviewHint_other: '{{count}} gastos detectats. Desmarca els que no vulguis i toca una fila per editar-la.',
      noDescription: 'Sense descripció',
      noRate: 'sense canvi',
      rateFailed: 'No s’ha pogut obtenir el canvi d’avui de {{currencies}}.',
      fixRow: 'Completa abans el gasto marcat.',
      include: 'Incloure aquest gasto',
      exclude: 'Deixar fora aquest gasto',
      selectedTotal_one: '{{count}} seleccionat',
      selectedTotal_other: '{{count}} seleccionats',
      addSelected_one: 'Afegir {{count}} gasto',
      addSelected_other: 'Afegir {{count}} gastos',
      savedCount_one: '{{count}} gasto afegit',
      savedCount_other: '{{count}} gastos afegits',
      savedFailed_one: 'No s’ha pogut desar {{count}} gasto',
      savedFailed_other: 'No s’han pogut desar {{count}} gastos',
    },
    form: {
      reservation: 'Reserva vinculada', reservationNone: '— Cap —',
      description: 'Descripció', descriptionPlaceholder: 'p.ex. Reserva d\'hotel',
      category: 'Categoria', payment: 'Pagament', amount: 'Import',
      currency: 'Moneda', date: 'Data', status: 'Estat',
      splitBetween: 'Dividir entre', perPerson: '{{currency}} {{amount}} / persona',
      notes: 'Notes', saveChanges: 'Desa els canvis', addExpense: 'Afegeix despesa',
      paidBy: 'Pagat per', you: 'Tu', noCurrencies: 'Sense resultats',
      conversion: {
        title: 'Converteix a {{currency}}',
        loading: 'Carregant…', refresh: 'Actualitza el tipus',
        manual: 'Tipus no disponible — introdueix-lo manualment.',
        asOf: 'Tipus del {{date}}',
      },
    },
    categories: {
      ACCOMMODATION: 'Allotjament', FLIGHTS: 'Vols', FOOD: 'Menjar',
      ACTIVITIES: 'Activitats', TRANSPORT: 'Transport',
      FUEL: 'Gasolina', PARKING: 'Pàrquing', CASH: 'Efectiu', OTHER: 'Altres',
    },
    payment: { CARD: 'Targeta', CASH: 'Efectiu', TRANSFER: 'Transferència' },
    status: { PAID: 'Pagat', PENDING: 'Pendent' },
    settlement: {
      title: 'Pla de liquidació', even: 'Tots esteu al dia',
      allDone: 'Totes les transferències confirmades', pending: '{{pending}} de {{total}} pendents',
      allEven: 'Tots esteu al dia — no calen transferències!',
      confirmed: 'Confirmat', settle: 'Liquida', undo: 'Desfés',
      onlySelf: 'Afegeix més participants al viatge per dividir despeses i veure qui deu què.',
      payIn: 'Paga en', markSettled: 'Marca com a liquidada',
      rateUnavailable: 'Tipus de canvi no disponible',
      paidAs: 'Pagat com a {{amount}} {{currency}}',
    },
    budget: {
      title: 'Pressupostos', manage: 'Pressupostos', set: 'Fixar pressupostos', edit: 'Editar',
      empty: 'Sense pressupostos',
      emptyDesc: 'Fixa límits de despesa per total, dia, categoria o persona i rep un avís abans de passar-te.',
      total: 'Total del viatge', daily: 'Per dia',
      categorySection: 'Per categoria', personSection: 'Per persona',
      tripSection: 'Límits de tot el viatge',
      tripSectionHint: 'Aquests topalls s’apliquen a tot el viatge, no per dia.',
      dailySection: 'Topall diari',
      dailyHint: 'Un topall per a cada dia — t’avisem quan un dia s’hi acosta o el supera.',
      noLimit: 'Sense límit',
      leftAmount: 'Queden {{amount}}', overAmount: 'Superat per {{amount}}', atLimit: 'Límit assolit',
      worstDay: 'Pitjor dia: {{amount}}',
      daysOver_one: '{{count}} dia per sobre del límit', daysOver_other: '{{count}} dies per sobre del límit',
      save: 'Desar pressupostos', saved: 'Pressupostos desats', failed: 'No s’han pogut desar els pressupostos',
      alertsTitle: 'Alertes de pressupost',
      overToast: 'Atenció — acabes de passar-te del pressupost de {{label}}',
      warnToast: 'T’estàs acostant al pressupost de {{label}}',
    },
    debts: {
      title: 'Deutes liquidats', recalculate: 'Recalcula',
      showSettled: 'Mostra liquidats ({{count}})', hideSettled: 'Amaga liquidats ({{count}})',
    },
    empty: {
      title: 'Controla les despeses compartides',
      desc: 'Registra cada despesa i divideix-la entre els viatgers. L\'app calcula qui deu què i et permet liquidar deutes amb un toc.',
      addFirst: 'Afegeix la primera despesa',
    },
    toast: {
      settled: 'Deute liquidat!', recalculated: 'Deutes recalculats', deleted: 'Despesa eliminada',
      updated: 'Despesa actualitzada!', added: 'Despesa afegida!',
      failedUpdate: 'Error en actualitzar la despesa', failedAdd: 'Error en afegir la despesa',
      selectParticipant: 'Selecciona almenys un participant', loadFailed: 'Error en carregar les despeses',
      rateRequired: 'Introdueix un tipus de canvi vàlid',
    },
    filters: {
      button: 'Filtrar', clear: 'Neteja', day: 'Dia', category: 'Categoria',
      paidBy: 'Pagat per', remove: 'Treure {{filter}}',
      showing_one: '{{count}} despesa', showing_other: '{{count}} despeses',
    },
    table: {
      all: 'TOTES', noFilter: 'Cap despesa coincideix amb el filtre',
      date: 'Data', item: 'Concepte', category: 'Categoria', paidBy: 'Pagat per', split: 'Divisió', amount: 'Import',
      editRow: 'Edita {{description}}',
      linkedReservation: 'Vinculat a una reserva',
    },
    spendingByPerson: 'Despesa per persona',
    byPerson: {
      traveller: 'Viatger', paid: 'Pagat', share: 'La seva part', balance: 'Balanç',
      formerTraveller: 'Viatger que ja no hi és',
      hint: 'Pagat és el que va posar. La seva part és el que li toca segons el repartiment.',
    },
    spendingByDay: 'Despesa per dia',
    byCategory: 'Per categoria',
    whoOwesWhom: 'Qui deu a qui',
    settledCount: 'Liquidat · {{count}}',
    baseCurrency: {
      title: 'Moneda base',
      desc: 'Els balanços i el pressupost es mostren en aquesta moneda; les despeses en altres monedes s’hi converteixen. Només la pots canviar abans d’afegir cap despesa.',
      edit: 'Canvia la moneda base',
      saving: 'Desant…',
      saved: 'Moneda base actualitzada',
      failed: 'No s’ha pogut actualitzar la moneda base',
    },
  },
  info: {
    deleteTip: 'Elimina el consell',
    tipsSectionTitle: 'Tips',
    title: 'Consells de viatge', subtitle: 'Consells segons la teva destinació',
    tips: 'Consells de viatge',
    heading: 'Consells de viatge',
    quickSuggestions: 'Suggeriments ràpids',
    acceptAndAdd: 'Acceptar i afegir',
    discard: 'Descartar',
    saving: 'Desant…',
    tipsProposalLabel: 'Proposta · {{count}} tips',
    tipsAdded_one: '{{count}} tip afegit',
    tipsAdded_other: '{{count}} tips afegits',
    loadFailed: 'Error en carregar els consells',
    tipsGenerateFailed: 'Error en generar tips',
    tipsSaveFailed: 'Error en desar tips',
    tipsAiDefault: "Dona'm els tips més útils per a aquesta destinació.",
    tipsAiPlaceholder: 'Ex: tips per a algú que hi va per primera vegada…',
    tipsAiMorePlaceholder: 'Demana més tips o ajustos…',
    addTipCategoryPlaceholder: 'Categoria',
    addTipContentPlaceholder: 'Contingut del tip…',
    addTipBtn: 'Afegir tip',
    addTipLabel: 'Afegir un tip',
    suggestedCategories: 'Categories suggerides',
    tipCategories: ['Transport', 'Visats i entrada', 'Diners i caixers', 'Seguretat', 'Idioma', 'Costums locals', 'Targeta SIM', 'Clima'] as string[],
    tipsPrompts: ["Tips essencials per a aquesta destinació", 'Transport públic i taxis', 'Diners, propines i caixers', 'Seguretat i estafes habituals', "Frases útils en l'idioma local", 'Costums locals'] as string[],
  },
  meals: {
    savedFlash: "Desat",
    title: 'Menjars',
    subtitle: 'Què es menja cada dia, i què cal comprar per fer-ho.',
    slot: {
      BREAKFAST: 'Esmorzar', LUNCH: 'Dinar', SNACK: 'Berenar',
      DINNER: 'Sopar', OTHER: 'Altres',
    },
    addTo: 'Afegir {{slot}}',
    addAtPlace: 'En un restaurant',
    pickSaved: 'Tria\'n un de desat',
    placeholder: 'Pasta amb salmó, sopar a Dill…',
    notesPlaceholder: 'Notes (opcional)',
    linkVenue: 'Enllaçar un lloc',
    editMeal: 'Editar l’àpat',
    noVenue: 'Sense lloc',
    searchPlace: 'Cerca un restaurant o cafeteria…',
    venueHint: 'Tria un restaurant o cafeteria desat, o cerca\'l: es desarà a Llocs.',
    emptyDay: 'Res planificat',
    ingredients: {
      title: 'Ingredients', add: 'Afegir ingredient',
      namePlaceholder: 'Salmó, pasta…', amountPlaceholder: 'Quant.', amountLabel: 'Quantitat',
      unit: 'Unitat', remove: 'Treure {{name}}',
      unitMismatch: 'Aquest producte ja es compta en una altra unitat',
      editAmount: 'Canviar la quantitat de {{name}}',
    },
    units: { u: 'u.', g: 'g', kg: 'kg', ml: 'ml', l: 'l' },
    pantry: {
      title: 'Rebost',
      hint: 'El que heu comprat, menys el que s’han menjat els àpats dels dies passats.',
      left: 'en queden {{amount}}', missing: 'en falten {{amount}}',
      planned: 'pla {{amount}}', bought: 'comprat {{amount}}', pending: '{{amount}} a la llista',
      addMissingFor: 'Afegir el que falta de {{name}} a la llista',
      added: '{{name}} afegit a la llista',
      addShort: 'Afegir', onList: 'A la llista',
    },
    grocery: {
      setAmount: 'quantitat',
      amountLabel: 'Quantitat a comprar', unitLabel: 'Unitat de compra',
      title: 'Llista de la compra',
      add: 'Afegir a la llista',
      placeholder: 'Salmó fresc',
      forMeal: 'per a {{title}}',
      empty: 'Encara no hi ha res per comprar.',
      emptyHint: 'Apunta el que necessiten els menjars i ratlla-ho a la botiga.',
      bought_one: '{{count}} al cistell',
      bought_other: '{{count}} al cistell',
      clearBought: 'Buidar el que ja és comprat',
      cleared_one: '{{count}} article eliminat',
      cleared_other: '{{count}} articles eliminats',
      collapse: 'Amagar la llista de la compra',
      expand: 'Mostrar la llista de la compra',
    },
    toast: {
      created: 'Menjar afegit',
      deleted: 'Menjar eliminat',
      saveFailed: 'No s\'ha pogut desar el menjar',
      deleteFailed: 'No s\'ha pogut eliminar el menjar',
      groceryFailed: 'No s\'ha pogut desar la llista de la compra',
      stopFailed: "No s'ha pogut actualitzar la parada de l'itinerari",
    },
    // ADR-0024: a meal linked to a stop of its day.
    stop: {
      pick: "Vincular a una parada…",
      create: "Afegir a l'itinerari",
      timePlaceholder: "Hora",
      hint: "Vinculat a una parada, el títol i el lloc són els mateixos a tots dos.",
      linked: "A l'itinerari",
      linkedAt: "A l'itinerari a les {{time}}",
      otherDay: "La seva parada és al dia {{day}}",
      unlink: "Desvincular",
      badge: "Pla",
    },
    deleteLinked: {
      title: "Aquest àpat és una parada de l'itinerari",
      body: "Vols esborrar també la parada?",
      only: "Només l'àpat",
    },
  },
  packing: {
    outfits: {
      heading: "Roba per dia",
      hint: "Planifica què et posaràs cada dia amb la roba de la teva maleta. Separa el dia en moments només si t’ajuda (platja, sopar…).",
      piecePlaceholder: "Escriu o tria una peça…",
      addNew: "Afegir «{{text}}» a la teva maleta",
      addNewTo: "Afegir «{{text}}» a {{section}}",
      sectionEmpty: "No queda res en aquesta secció — escriu una peça per afegir-la.",
      fromSection: "De la secció",
      suitcaseEmpty: "Encara no tens roba a la maleta — escriu una peça per afegir-la.",
      addPiece: "Afegir roba",
      addGroup: "Separar per moments del dia",
      groupPrompt: "Per a quin moment?",
      groupPresets: ["Platja", "Sopar", "Esport", "Excursió", "Sortir de nit"],
      dragHint: "Arrossega-la a un altre moment",
      allDay: "Tot el dia",
      groupPlaceholder: "Un altre moment…",
      groupName: "Nom del moment",
      renameGroup: "Canviar el nom del moment",
      deleteGroup: "Treure el moment",
      deleteGroupHint: "La seva roba torna a «Tot el dia»",
      removePiece: "Treure {{text}} d’aquest dia",
      packed: "A la maleta",
      notPacked: "Encara no és a la maleta",
      pieceCount_one: "{{count}} peça",
      pieceCount_other: "{{count}} peces",
      emptyDay: "Res previst",
      loadFailed: "No s’ha pogut carregar la roba per dia",
      addFailed: "No s’ha pogut afegir la peça",
    },
    addSuggested_one: 'Afegeix {{count}} secció',
    addSuggested_other: 'Afegeix {{count}} seccions',
    addSectionFailed: 'No s’ha pogut afegir la secció',
    scope: {
      mine: 'Meva', common: 'Comuna', someone: 'Algú',
    },
    sharing: {
      on: 'La veu el grup', off: 'Només jo',
      onHint: 'Els altres veuen la teva maleta. Prem per guardar-te-la.',
      offHint: 'Només tu veus la teva maleta. Prem per compartir-la amb el grup.',
      nowShared: 'La teva maleta ja la veu el grup',
      nowPrivate: 'La teva maleta ja és privada',
      failed: 'No s’ha pogut canviar qui veu la teva maleta',
    },
    copy: {
      button: 'Copiar d’un altre viatge',
      title: 'Copiar apartats de maleta',
      pickTrip: 'De quin viatge vols copiar?',
      noTrips: 'Encara no tens altres viatges dels quals copiar.',
      backToTrips: 'Tria un altre viatge',
      pickSections: 'Apartats a copiar',
      items_one: '{{count}} cosa',
      items_other: '{{count}} coses',
      selectAll: 'Selecciona-ho tot',
      clearAll: 'Treure-ho tot',
      nothingToCopy: 'Aquest viatge encara no té apartats de maleta amb coses a dins.',
      mergeHint: 'Els apartats amb el mateix nom es fusionen i el que ja tens no es duplica.',
      confirm_one: 'Copiar {{count}} apartat',
      confirm_other: 'Copiar {{count}} apartats',
      copying: 'Copiant…',
      done_one: '{{count}} cosa afegida',
      done_other: '{{count}} coses afegides',
      nothingNew: 'Ja tenies tot això a la teva llista',
      loadFailed: 'No s’ha pogut carregar la maleta d’aquest viatge',
      failed: 'No s’han pogut copiar els apartats',
    },
    assignee: { label: 'Qui ho porta', nobody: 'Ningú encara' },
    readOnlyHint: 'La maleta d’una altra persona: la pots veure, però no canviar.',
    emptySection: 'Aquí encara no hi ha res',
    completedProgress: '{{done}}/{{total}} completat · {{pct}}%',
    title: 'Maleta', subtitle: 'El teu checklist d\'equipatge',
    checklists: 'Checklists pre-viatge',
    heading: 'Maleta',
    quickSuggestions: 'Suggeriments ràpids',
    acceptAndAdd: 'Acceptar i afegir',
    discard: 'Descartar',
    saving: 'Desant…',
    packingProposalLabel: 'Proposta · {{sections}} seccions · {{items}} items',
    sectionsAdded_one: '{{count}} secció afegida al teu checklist',
    sectionsAdded_other: '{{count}} seccions afegides al teu checklist',
    sectionRemoved: 'Secció eliminada',
    loadFailed: 'Error en carregar la maleta',
    packingGenerateFailed: 'Error en generar la llista de maletes',
    packingGenerateSaveFailed: 'Error en desar la llista de maletes',
    packingAiDefault: 'Genera una llista de maletes completa i personalitzada.',
    packingAiPlaceholder: "Ex: Per a dona, viatge de 5 dies a l'estiu…",
    packingAiMorePlaceholder: 'Demana més seccions o ajustos…',
    suggestedSections: 'Seccions suggerides',
    newSectionPlaceholder: 'Nova secció (ex: Documents, Reserves…)',
    addSection: 'Secció',
    addSectionLabel: 'Afegir una secció',
    addItemPlaceholder: 'Afegir element…',
    addItemBtn: 'Afegir',
    done: 'Fet ✓',
    packingPrompts: ['Per a home', 'Per a dona', 'Família amb nens', 'Viatge de negocis', 'Motxiller', 'Platja / estiu', 'Muntanya / senderisme'] as string[],
    defaultSectionNames: ['Documents', 'Roba', 'Neceser', 'Electrònica', 'Medicaments', 'Reserves', 'Diners'] as string[],
    sectionAiButton: 'Genera elements amb IA',
    sectionAiPlaceholder: 'Opcional: quants dies, clima, activitats previstes…',
    sectionAiGenerate: 'Genera',
    sectionAiPrompt: 'Genera NOMÉS elements nous per afegir a la secció de la llista de maleta "{{title}}" d\'aquest viatge. Context addicional de l\'usuari: {{info}}. No repeteixis elements que ja hi ha a la llista: {{existing}}. Retorna una única secció anomenada exactament "{{title}}" amb només els elements nous.',
    sectionAiNoExtraInfo: 'cap especificat',
    sectionAiNoExistingItems: 'cap encara',
    sectionAiAdded_one: 'Afegit {{count}} element a "{{title}}"',
    sectionAiAdded_other: 'Afegits {{count}} elements a "{{title}}"',
    sectionAiEmpty: 'La IA no ha suggerit cap element nou per a aquesta secció',
    sectionAiFailed: 'No s\'han pogut generar els elements — torna-ho a provar',
    dragHandle: 'Arrossega per reordenar',
    reorderFailed: 'No s\'ha pogut desar el nou ordre',
    deleteSection: 'Elimina la secció',
    deleteItem: 'Elimina l\'element',
    editItem: 'Prem per editar',
    renameItemFailed: 'No s\'ha pogut reanomenar l\'element',
    checkItem: 'Marca com a preparat',
    uncheckItem: 'Marca com a no preparat',
  },
  shared: {
    viewOnly: 'Viatge compartit (només lectura)',
    noDiary: 'Encara no hi ha res escrit al diari.',
    follow: { title: 'Seguir aquest viatge', hintAccount: "T'avisarem a l'app quan el grup escrigui al diari.", hintEmail: 'Rep un correu quan el grup escrigui al diari.', follow: 'Seguir', following: 'Seguint', followed: 'Segueixes aquest viatge', unfollowed: 'Ja no segueixes aquest viatge', error: 'Alguna cosa ha fallat. Torna-ho a provar.', emailPlaceholder: 'El teu correu', subscribe: "Avisa'm", checkInbox: 'Revisa el correu per confirmar-ho.', confirmed: "Fet! T'escriurem quan hi hagi alguna cosa nova.", unsubscribed: 'No rebràs més correus d’aquest viatge.', linkExpired: 'Aquest enllaç ja no funciona.' },
    notFoundTitle: 'Viatge no trobat',
    notFoundDesc: "Aquest enllaç no és vàlid o el propietari ha desactivat l'opció de compartir.",
    nights_one: '{{count}} nit', nights_other: '{{count}} nits',
    traveller_one: '{{count}} viatger', traveller_other: '{{count}} viatgers',
    sections: {
      diary: 'Diari',
      flights: 'Vols', accommodation: 'Allotjament', itinerary: 'Itinerari', about: 'Sobre el viatge',
      places: 'Llocs', map: 'Mapa', travel: 'Viatge',
      tips: 'Consells', photos: 'Fotos', meals: 'Àpats', bookings: 'Reserves',
    },
    footer: 'Compartit amb Gromly · Només lectura',
    outbound: 'Anada', return: 'Tornada', noActivities: 'Sense activitats planificades',
    optional: 'Opcional',
    noPlaces: 'No hi ha llocs desats.', noTips: 'Encara no hi ha consells.', noPhotos: 'Encara no hi ha fotos.', noBookings: 'Encara no hi ha res reservat.',
    openInMaps: 'Obre a Google Maps',
    map: {
      allPlaces: 'Tots els llocs', dayByDay: 'Dia a dia', dayLabel: 'Dia {{n}}',
      unavailable: 'Mapa no disponible', noRouteYet: 'La ruta d’aquest dia encara no està calculada.',
    },
  },
  account: {
    storage: { title: "Emmagatzematge", photos: "Fotos", used: "{{used}} de {{quota}}", full: "El teu espai per a fotos és ple. Esborra’n alguna per poder-ne pujar de noves." },
    avatar: { change: "Canvia la foto", add: "Afegeix una foto", remove: "Treu la foto", cropTitle: "Enquadra la teva foto", zoom: "Zoom", save: "Desa la foto", saved: "Foto de perfil actualitzada", removed: "Foto de perfil eliminada", failed: "No s'ha pogut actualitzar la teva foto", unsupported: "Aquest fitxer no és una foto que puguem fer servir" },
    birthDate: "Data de naixement", birthDateHint: "Només la veus tu. Els teus viatges només veuen la teva edat, per avisar-te de tarifes i avantatges per edat.", birthDateSaved: "Data de naixement desada", birthDateSaveFailed: "No s'ha pogut desar la teva data de naixement",
    nationality: "Nacionalitat", nationalitySaveFailed: "No s'ha pogut actualitzar la nacionalitat",
    title: 'Compte',
    subtitle: 'Gestiona el teu perfil i preferències',
    profile: 'Perfil',
    memberSince: 'Membre des de',
    credits: 'Crèdits',
    tripCredits: 'Crèdits de viatge',
    aiCredits: 'Crèdits IA',
    plan: { title: "Pla", gift: "Regal de Gromly", free: "Gratuït", proUntil: "PRO fins al {{date}}", manage: "Gestionar la subscripció", inStore: "Gestiona-la a {{store}}", upgrade: "Fes-te PRO", restore: "Restaurar compres", restored: "Compres restaurades", nothing: "No hi ha compres per restaurar" },
    security: 'Seguretat',
    changePassword: {
      title: 'Canviar contrasenya',
      rowHint: 'Actualitza la contrasenya amb què entres',
      setTitle: 'Posar una contrasenya',
      setHint: 'El teu compte encara no té contrasenya',
      setLinkSent: "T'hem enviat un enllaç per posar una contrasenya.",
      setLinkFailed: "No hem pogut enviar l'enllaç. Torna-ho a provar d'aquí a uns minuts.",
      current: 'Contrasenya actual',
      new: 'Nova contrasenya',
      confirm: 'Repeteix la nova contrasenya',
      signsOutOthers: 'Aquí continuaràs dins, però es tancarà la sessió a la resta de dispositius.',
      submit: 'Canviar contrasenya',
      success: 'Contrasenya canviada.',
      wrongCurrent: 'Aquesta no és la teva contrasenya actual.',
      unchanged: 'La nova contrasenya és la mateixa que l\'actual.',
      googleAccount: "Aquest compte entra amb Google. Fes servir l'enllaç del correu per posar una contrasenya.",
      failed: 'No hem pogut canviar la contrasenya. Torna-ho a provar.',
    },
    twoFactor: 'Autenticació de dos factors',
    enabled: 'Activat',
    notEnabled: 'No activat',
    data: 'Dades i privadesa',
    exportData: 'Exportar les meves dades',
    exportDataDesc: 'Descarrega una còpia de totes les teves dades',
    danger: 'Zona de perill',
    signOut: 'Tancar sessió',
    deleteAccount: 'Eliminar compte',
    deleteAccountDesc: 'Elimina permanentment el teu compte i totes les teves dades',
    deleteConfirmTitle: 'Eliminar compte',
    deleteConfirmSubtitle: 'Aquesta acció és permanent',
    deleteConfirmBody: 'Tots els teus viatges, despeses, reserves i dades personals seran eliminats permanentment. Aquesta acció no es pot desfer.',
    deleting: 'Eliminant…',
    deletePermanently: 'Eliminar permanentment',
    saveFirst: 'Vols desar les teves dades primer?',
    exportFailed: 'Error en exportar les dades. Si us plau, torna-ho a intentar.',
    deleteFailed: 'Error en eliminar el compte. Si us plau, torna-ho a intentar.',
  },
  docs: {
    hero: {
      title: 'Documentació de Gromly',
      subtitle: 'Tot el que necessites saber per planificar, col·laborar i viatjar amb Gromly.',
      back: 'Torna al tauler',
    },
    sidebar: { sections: 'Seccions' },
    footer: { title: 'Llest per planificar?', subtitle: 'Torna al tauler i crea el teu primer viatge.', cta: 'Ves al tauler' },
    itinerary: {
      title: 'Itinerari', subtitle: 'Planifica els teus dies, hora a hora',
      p1: "L'itinerari és el cor del teu viatge. Afegeix activitats a cada dia, reordena-les arrossegant-les, i cada dia nou continua automàticament des d'on va acabar l'anterior.",
      feat_addDay_label: 'Afegeix dia', feat_addDay_desc: 'Fes clic a "Afegeix dia" per crear un nou dia. Les dates s\'assignen automàticament des de la data d\'inici del viatge.',
      feat_drag_label: 'Arrossega i deixa anar', feat_drag_desc: "Reordena activitats dins d'un dia arrossegant la maneta.",
      feat_ai_label: 'Planificació amb IA', feat_ai_desc: "Fes clic al botó d'IA per obrir el xat. Demana-li que afegeixi activitats, suggereixi què visitar o mogui coses.",
      tip1: "Canvia entre les vistes Llista i Cronologia amb el selector de la capçalera. La vista Cronologia fusiona vols, hotels i activitats en un únic feed cronològic.",
      step1: 'Fes clic a "Afegeix dia" per crear el teu primer dia.',
      step2: 'Fes clic a "+ Afegeix activitat" per afegir activitats al dia.',
      step3: "Omple el títol, el tipus (Restaurant, Monument, etc.) i els detalls opcionals.",
      step4: 'Arrossega les activitats per reordenar-les dins del dia.',
    },
    places: {
      title: 'Llocs', subtitle: 'La teva llista de desitjos personal per al destí',
      p1: "Llocs és la teva llista curada de llocs per visitar: restaurants que provar, monuments que veure, barris per explorar, botigues per visitar. Tot organitzat per categoria.",
      feat_add_label: 'Afegeix lloc', feat_add_desc: 'Usa el botó "+ Afegeix lloc" o demana a la IA que l\'afegeixi amb enriquiment automàtic de Google Maps.',
      feat_visited_label: 'Marca com visitat', feat_visited_desc: "Toca el check a la targeta del lloc un cop hi hagis estat. Els llocs visitats queden en gris però es conserven a la teva llista.",
      feat_ai_label: 'Recomanacions IA', feat_ai_desc: 'Obre el xat d\'IA i pregunta "Dona\'m 5 restaurants al casc antic". Els afegirà directament a la teva llista.',
      tip1: "Els llocs afegits aquí apareixen automàticament com a opcions de pin a la pestanya Mapa. Pots vincular un lloc directament a una activitat de l'itinerari amb el botó \"Afegeix a l'itinerari\".",
    },
    map: {
      title: 'Mapa', subtitle: 'Visualitza rutes i optimitza el teu dia',
      p1: "La pestanya Mapa mostra tots els teus llocs desats com a pins. Selecciona un dia al desplegable per veure només les activitats d'aquell dia amb una ruta traçada entre elles.",
      feat_route_label: 'Ruta del dia', feat_route_desc: "Selecciona un dia per veure una ruta connectada entre totes les activitats en ordre. Toca un pin per veure'n els detalls.",
      feat_reorder_label: 'Reordena parades', feat_reorder_desc: "Al panell de ruta, arrossega les parades per canviar-ne l'ordre. La ruta al mapa s'actualitza en temps real.",
      feat_ai_label: 'Optimitza amb gIA', feat_ai_desc: 'Toca "Optimitza amb gIA" perquè la IA reordeni les teves parades geogràficament i minimitzi els desplaçaments.',
      tip1: "Al mòbil, el panell de ruta puja des de la part inferior com un full. Llisca'l cap avall per amagar-lo i obtenir una vista de mapa completa.",
    },
    bookings: {
      title: 'Reserves', subtitle: 'Vols, hotels, transport i entrades — tot en un lloc',
      p1: "Reserves centralitza totes les reserves del teu viatge: vols d'anada i tornada, check-ins d'hotel, trams de transport (tren, bus, taxi) i entrades a esdeveniments o activitats.",
      feat_flights_label: 'Vols', feat_flights_desc: "Afegeix vols d'anada i tornada amb aerolínia, número de vol, aeroports i referència de reserva.",
      feat_hotels_label: 'Hotels', feat_hotels_desc: "Registra el teu allotjament amb dates d'entrada i sortida, adreça i URL de reserva.",
      feat_bookings_label: 'Reserves i entrades', feat_bookings_desc: "Afegeix qualsevol altra reserva: teatre, partit de futbol, entrada a museu, bitllet de bus — amb data, lloc i referència.",
      feat_docs_label: 'Adjunta documents', feat_docs_desc: 'Puja PDFs, captures, fotos o el mateix correu de confirmació (.eml) directament a una reserva. S\'emmagatzemen de forma segura al núvol.',
      tip1: "Desa el correu de confirmació com a .eml i puja'l tal qual: la IA llegeix el missatge i els bitllets que porti adjunts, i el tens accessible sense connexió. L'app mostrarà un recordatori 48 hores abans de cada vol o hotel.",
      warning1: "Les pujades de documents requereixen que Cloudflare R2 estigui configurat al servidor. Contacta amb el teu administrador si el botó de pujada està desactivat.",
    },
    expenses: {
      title: 'Despeses i pressupost', subtitle: 'Controla les despeses i liquida deutes automàticament',
      p1: "La pestanya de Despeses és un rastrejador complet de despeses en grup. Registra què s'ha gastat, qui ha pagat, com es reparteix i deixa que l'app calculi la manera més senzilla de liquidar.",
      feat_add_label: 'Afegeix despesa', feat_add_desc: "Registra qui ha pagat, l'import, la divisa, la categoria (Allotjament, Menjar, Transport…) i com dividir-ho.",
      feat_settle_label: 'Liquidació automàtica', feat_settle_desc: 'Fes clic a "Recalcula" per obtenir el conjunt mínim de pagaments que liquida tots els deutes.',
      feat_debt_label: 'Liquida deute', feat_debt_desc: "Un cop pagat un deute a la vida real, toca \"Liquida\" per marcar-lo com a fet. Els deutes liquidats es conserven com a referència.",
      feat_budget_label: 'Control de pressupost', feat_budget_desc: "Toca la icona del llapis a la targeta de Pressupost per establir un pressupost total. Una barra de progrés mostra quant has usat per categoria.",
      tip1: "La barra de pressupost es torna ambre en arribar al 80% i vermella en superar-lo. Estableix-la a l'inici del viatge per saber sempre on ets.",
      step1: 'Obre Despeses i fes clic a "Afegeix despesa".', step2: "Selecciona qui ha pagat i l'import.",
      step3: 'Tria com dividir: a parts iguals o imports personalitzats.',
      step4: 'Després d\'afegir diverses despeses, fes clic a "Recalcula" per obtenir el pla de liquidació.',
      step5: 'Quan es realitzi un pagament, toca "Liquida" per tancar el deute.',
    },
    info: {
      title: 'Info i consells', subtitle: 'Consells, checklists i coneixement local',
      p1: "Info i Consells té dues seccions: un tauler lliure de consells organitzat per categoria (Transport, Menjar, Cultura, Diners…) i checklists pre-viatge per fer la maleta i preparar-se.",
      feat_tips_label: 'Consells', feat_tips_desc: 'Afegeix consells curts per categoria. Ideal per a notes com "El metro tanca a mitjanit" o "Reserva restaurants amb 2 setmanes d\'antelació".',
      feat_checklists_label: 'Checklists', feat_checklists_desc: 'Crea seccions de checklist (Documents, Roba, Electrònica…) i afegeix elements a cada una. Marca\'ls en fer la maleta.',
      feat_ai_label: 'Llista de maleta amb IA', feat_ai_desc: 'Fes clic a "Genera amb IA" per obtenir una llista d\'equipatge personalitzada segons el teu destí, durada, època i activitats planificades.',
      tip1: "La llista de maleta amb IA es genera com a seccions de checklist perquè puguis editar-la, afegir-hi o eliminar-ne elements després. És un punt de partida, no una llista fixa.",
      step1: 'Afegeix una secció de checklist (p. ex. "Documents") amb el camp de text de baix.',
      step2: 'Escriu els elements un a un i prem Enter per afegir-los.',
      step3: 'O fes clic a "Genera amb IA" per crear automàticament una llista d\'equipatge completa.',
      step4: "En fer la maleta, marca els elements. La barra de progrés de dalt indica l'avenç.",
    },
    ai: {
      title: 'Assistent IA', subtitle: 'El teu company de viatge intel·ligent',
      p1: "L'assistent d'IA és conscient del context: coneix el teu destí, les dates del viatge i el que ja hi ha al teu viatge. Funciona de manera diferent segons la pestanya on estiguis.",
      feat_places_label: 'Mode Llocs', feat_places_desc: 'Escriu "Afegeix la Sagrada Família als meus llocs" i la trobarà a Google Maps, omplirà l\'adreça i crearà el lloc automàticament.',
      feat_itinerary_label: 'Mode Itinerari', feat_itinerary_desc: "Demana-li que afegeixi activitats a dies i franges horàries concretes, o que mogui activitats existents. Coneix el teu itinerari actual.",
      feat_route_label: 'Mode Ruta', feat_route_desc: "A la pestanya Mapa, demana-li que reordeni les parades del dia seleccionat per minimitzar el temps de desplaçament entre zones.",
      feat_packing_label: 'Mode Maleta', feat_packing_desc: "A Info i Consells, genera una llista d'equipatge completa adaptada al teu destí, època i tipus d'activitats.",
      tip1: "Parla amb la IA en qualsevol idioma: respondrà en l'idioma que facis servir. Sigues específic: \"Afegeix 3 bars de tapes prop del Barri Gòtic per sopar\" funciona millor que \"Afegeix restaurants\".",
      warning1: "La IA requereix una clau d'API d'OpenAI configurada al servidor. Si el botó del xat d'IA està desactivat o dona error, demana al teu administrador que comprovi la clau.",
    },
    sharing: {
      title: 'Comparteix el viatge', subtitle: 'Permet que qualsevol vegi el teu viatge sense tenir compte',
      p1: "La funció Comparteix el viatge genera un enllaç públic únic que permet a qualsevol — fins i tot sense compte — veure el teu viatge en mode de només lectura: itinerari, vols, hotels i notes.",
      feat_enable_label: 'Activa el compartir', feat_enable_desc: "A la barra lateral del viatge, fes clic a \"Comparteix el viatge\" i després a \"Activa el compartir\". Es genera immediatament una URL única.",
      feat_copy_label: 'Copia l\'enllaç', feat_copy_desc: "Copia l'enllaç i envia'l a familiars o amics. Poden veure l'itinerari complet però no editar res.",
      feat_disable_label: 'Desactiva el compartir', feat_disable_desc: "Fes clic a \"Desactiva el compartir\" en qualsevol moment per invalidar l'enllaç. Qui tingui l'URL antiga veurà una pàgina \"No trobat\".",
      tip1: "La vista compartida és una pàgina neta i adaptada al mòbil que no requereix inici de sessió. Perfecta per enviar l'itinerari a un familiar que vulgui seguir el teu viatge.",
      warning1: "Només el propietari del viatge pot activar o desactivar el compartir. Els participants amb rols EDITOR o VIEWER no poden gestionar l'enllaç.",
    },
    participants: {
      title: 'Participants', subtitle: 'Convida i gestiona el teu grup de viatge',
      p1: "Convida co-viatgers per col·laborar en el viatge. Cada participant té un rol que controla el que pot fer.",
      feat_invite_label: 'Convida per correu', feat_invite_desc: "El convidat ja ha de tenir compte. Introdueix el seu correu i tria un rol.",
      feat_editor_label: 'Rol EDITOR', feat_editor_desc: "Pot afegir, editar i eliminar contingut: activitats, llocs, despeses, reserves, consells i checklists.",
      feat_viewer_label: 'Rol VIEWER', feat_viewer_desc: "Accés de només lectura. Pot veure-ho tot però no fer canvis. Ideal per a algú que vol seguir el pla.",
      tip1: "Només el propietari pot convidar participants, canviar el seu rol o eliminar-los. El propietari també és l'únic que pot eliminar el viatge complet.",
      step1: "A la barra lateral del viatge, fes clic al botó de participants (mostra avatars i nombre de membres). Al mòbil, toca la icona de persones a la capçalera del viatge.",
      step2: 'Fes clic a "Convida participant" i introdueix l\'adreça de correu.',
      step3: 'Tria EDITOR (pot editar) o VIEWER (només lectura).',
      step4: 'El participant veurà el viatge al seu tauler immediatament.',
    },
    notifications: {
      title: 'Notificacions', subtitle: "Recordatoris a l'app per a esdeveniments pròxims",
      p1: "L'app mostra recordatoris quan la sortida d'un vol o el check-in d'un hotel és a les properes 48 hores. No necessita configuració: funciona automàticament.",
      feat_flights_label: 'Recordatoris de vol', feat_flights_desc: 'Es mostren 48h abans de la sortida. Urgent (vermell) dins de les 12 hores.',
      feat_hotels_label: "Recordatoris d'hotel", feat_hotels_desc: 'Es mostren 48h abans del check-in. Urgent (vermell) dins de les 12 hores.',
      feat_where_label: 'On trobar-los', feat_where_desc: "Escriptori: panell ambre a la barra lateral del viatge. Mòbil: insígnia vermella a la pestanya Reserves de la barra de navegació inferior.",
      tip1: "Els recordatoris es calculen a partir dels teus vols i hotels a la pestanya Reserves. Assegura't d'afegir les hores de sortida reals per rebre alertes precises.",
    },
    community: {
      title: 'Explorar la comunitat', subtitle: 'Descobreix, valora i clona viatges d\'altres viatgers',
      p1: 'La secció Explorar és un feed públic de viatges compartits per la comunitat de Gromly. Explora destinacions, descobreix itineraris creats per viatgers reals i clona qualsevol viatge com a punt de partida.',
      feat_browse_label: 'Navegar i cercar', feat_browse_desc: 'Filtra per destinació o durada i ordena per Més recents, Millor valorats o Més usats. Usa la barra de cerca per a una destinació concreta.',
      feat_clone_label: 'Clonar un viatge', feat_clone_desc: 'Fes clic a "Usa aquest itinerari" per crear una còpia completa al teu tauler. El clon és independent — les teves edicions no afecten l\'original.',
      feat_rate_label: 'Valorar viatges', feat_rate_desc: 'Deixa una valoració d\'1 a 5 estrelles en qualsevol viatge publicat. Les valoracions ajuden a destacar els millors itineraris.',
      feat_follow_label: 'Seguir viatgers', feat_follow_desc: 'Segueix altres usuaris per filtrar el feed als seus viatges. Usa la pestanya "Seguint" per veure les seves últimes publicacions.',
      tip1: 'Per publicar el teu propi viatge, ves al tauler, obre el menú del viatge (tres punts) i fes clic a "Comparteix amb la comunitat".',
      step1: 'Ves a Explorar des de la barra de navegació superior.',
      step2: 'Usa la barra de cerca o les opcions d\'ordenació per trobar viatges.',
      step3: 'Fes clic en una targeta de viatge per veure l\'itinerari complet.',
      step4: 'Fes clic a "Usa aquest itinerari" per clonar-lo al teu tauler.',
    },
    account: {
      title: 'Compte i seguretat', subtitle: '2FA, controls de privadesa i les teves dades',
      p1: 'La configuració del teu compte és accessible des del menú d\'usuari (cantonada superior dreta). Des d\'allà pots gestionar l\'autenticació de dos factors, descarregar les teves dades i eliminar el teu compte.',
      feat_2fa_label: 'Autenticació de dos factors', feat_2fa_desc: 'Fes clic a "Seguretat" al menú d\'usuari per configurar el 2FA. Escaneja el codi QR amb Google Authenticator, Authy o qualsevol app TOTP.',
      feat_export_label: 'Descarregar les meves dades', feat_export_desc: 'Fes clic a "Descarregar les meves dades" al menú d\'usuari per exportar totes les teves dades personals en JSON (RGPD Art. 20 — portabilitat).',
      feat_delete_label: 'Eliminar compte', feat_delete_desc: 'Fes clic a "Eliminar compte" per eliminar permanentment el teu compte i totes les dades associades. Aquesta acció no es pot desfer.',
      tip1: 'Recomanem activar el 2FA: protegeix el teu compte fins i tot si la contrasenya és compromesa. Usa Google Authenticator, Authy, 1Password, etc.',
      warning1: 'Eliminar el compte és permanent i irreversible. S\'eliminaran tots els teus viatges, despeses, reserves i documents. Descarrega les teves dades primer si vols conservar-ne una còpia.',
    },
    pwa: {
      title: 'Instal·la com a app (PWA)', subtitle: 'Usa Gromly sense connexió a qualsevol dispositiu',
      p1: "Gromly és una Progressive Web App (PWA). Pots instal·lar-la al teu mòbil o escriptori i usar-la com una app nativa, fins i tot sense connexió a internet.",
      feat_ios_label: 'Instal·la a iOS', feat_ios_desc: 'Obre Gromly a Safari → toca el botó Comparteix → "Afegeix a la pantalla d\'inici". Fet.',
      feat_android_label: 'Instal·la a Android', feat_android_desc: 'Obre a Chrome → toca el menú de tres punts → "Afegeix a la pantalla d\'inici" o "Instal·la l\'app".',
      feat_desktop_label: 'Instal·la a l\'escriptori', feat_desktop_desc: 'A Chrome o Edge, busca la icona d\'instal·lació (➕) a la barra d\'adreces i fes clic.',
      tip1: "Gromly desa a la memòria cau els teus viatges, itinerari i reserves perquè carreguin a l'instant fins i tot sense connexió. Consultar-los funciona sense connexió; afegir o editar qualsevol cosa encara necessita connexió.",
    },
  },
  installPrompt: {
    title: 'Instal·la Gromly',
    subtitle: "Afegeix-la a la pantalla d'inici per accedir-hi ràpid i a pantalla completa.",
    install: 'Instal·la',
    iosIntro: 'Per instal·lar-la al teu iPhone:',
    iosStep1: 'Toca el botó Comparteix',
    iosStep2: "Tria «Afegeix a la pantalla d'inici»",
  },
  maps: {
    quotaExceeded: "Has arribat al límit de mapes d'aquest mes. Es reinicia el {{date}}.",
  },
  ai: {
    deleteActivity: "Elimina l'activitat",
    venueNotes: {
      title: 'Reescriure les notes de {{name}}', titleNew: 'Notes per a {{name}}',
      before: 'Ara', after: 'Proposta', emptied: '(notes buides)',
    },
    deletePlaces_one: 'Elimina el lloc',
    deletePlaces_other: 'Elimina {{count}} llocs',
    deleteAllPlaces_one: 'Buida la llista de llocs ({{count}} lloc)',
    deleteAllPlaces_other: 'Buida la llista de llocs ({{count}} llocs)',
    deleteTakesStops_one: 'També treu {{count}} parada de l\'itinerari',
    deleteTakesStops_other: 'També treu {{count}} parades de l\'itinerari',
    deleteExpenses_one: 'Elimina la despesa',
    deleteExpenses_other: 'Elimina {{count}} despeses',
    deleteAllExpenses_one: 'Buida el llibre de comptes ({{count}} despesa)',
    deleteAllExpenses_other: 'Buida el llibre de comptes ({{count}} despeses)',
    assistant: 'Assistent IA',
    name: 'gIA',
    expand: 'Obrir assistent',
    collapse: 'Replegar assistent',
    saveFailed: "No s'ha pogut desar",
    someNotSaved: "Algunes propostes no s'han pogut desar",
    error: 'Ho sento, ha ocorregut un error. Torna-ho a intentar.',
    clearConversation: 'Netejar conversa',
    expenseSplitHint: 'Pagues tu; es reparteix a parts iguals. Edita el detall a Despeses.',
    proposals_one: '{{count}} proposta',
    proposals_other: '{{count}} propostes',
    saving: 'Desant…',
    op: {
      tripDates: {
        title: 'Dates noves: {{from}} → {{to}}',
        addedDays_one: 'S\'afegeix {{count}} dia',
        addedDays_other: 'S\'afegeixen {{count}} dies',
        removedDays_one: 'Es treu {{count}} dia',
        removedDays_other: 'Es treuen {{count}} dies',
        movedStops_one: '{{count}} parada passa al dia {{day}}',
        movedStops_other: '{{count}} parades passen al dia {{day}}',
        removedMeals_one: 'Es perd {{count}} àpat planificat',
        removedMeals_other: 'Es perden {{count}} àpats planificats',
        removedOutfitDays_one: 'Es perd la roba prevista de {{count}} dia',
        removedOutfitDays_other: 'Es perd la roba prevista de {{count}} dies',
        outOfRange_one: '{{count}} reserva queda fora de les dates noves',
        outOfRange_other: '{{count}} reserves queden fora de les dates noves',
      },
      settleDebt: {
        title: '{{from}} ha pagat a {{to}} {{amount}}',
      },
      outfitAdd: {
        title: 'Portar {{item}} el dia {{day}}',
      },
      ingredientAdd: {
        title: 'Afegir {{amount}} {{unit}} de {{name}} a «{{meal}}»',
      },
      mealStop: {
        title: 'Posar «{{meal}}» com a parada del dia {{day}}',
      },
      duplicate: {
        title_one: 'Copiar {{count}} parada al dia {{day}}',
        title_other: 'Copiar {{count}} parades al dia {{day}}',
      },
      item: '– {{text}}',
    },
    cards: {
      empty: '(buit)',
      field: {
        title: 'Títol',
        notes: 'Notes',
        startTime: 'Hora',
        durationMins: 'Durada (min)',
        name: 'Nom',
        category: 'Categoria',
        customCategory: 'Categoria pròpia',
        zone: 'Zona',
        priceInfo: 'Preu',
        visited: 'Visitat',
        airline: 'Companyia',
        flightNumber: 'Número de vol',
        departureTime: 'Sortida',
        arrivalTime: 'Arribada',
        bookingRef: 'Localitzador',
        address: 'Adreça',
        checkIn: 'Entrada',
        checkOut: 'Sortida',
        bookingUrl: 'Enllaç de la reserva',
        type: 'Tipus',
        date: 'Data',
        endDate: 'Data de fi',
        endTime: 'Hora de fi',
        venue: 'Lloc',
        description: 'Descripció',
        amount: 'Import',
        content: 'Text',
        text: 'Article',
        checked: 'A la maleta',
        slot: 'Àpat',
        bought: 'Comprat',
        unit: 'Unitat',
      },
      entity: {
        day_one: 'dia', day_other: 'dies',
        venue_one: 'lloc', venue_other: 'llocs',
        flight_one: 'vol', flight_other: 'vols',
        hotel_one: 'allotjament', hotel_other: 'allotjaments',
        booking_one: 'reserva', booking_other: 'reserves',
        expense_one: 'despesa', expense_other: 'despeses',
        note_one: 'nota', note_other: 'notes',
        tip_one: 'consell', tip_other: 'consells',
        packing_section_one: 'secció de la maleta', packing_section_other: 'seccions de la maleta',
        packing_item_one: 'article de la maleta', packing_item_other: 'articles de la maleta',
        outfit_piece_one: 'peça prevista', outfit_piece_other: 'peces previstes',
        meal_one: 'àpat', meal_other: 'àpats',
        grocery_item_one: 'línia de la compra', grocery_item_other: 'línies de la compra',
      },
      yes: 'Sí',
      no: 'No',
      editItem: 'Canviar «{{label}}»',
      deleteItems_one: 'Esborrar {{count}} element',
      deleteItems_other: 'Esborrar {{count}} elements',
      packed: '✓ {{item}} a la maleta',
      unpacked: '○ {{item}} encara per posar',
      nights_one: '{{count}} nit',
      nights_other: '{{count}} nits',
      at: 'A {{place}}',
      editStop: 'Canviar «{{title}}»',
      packingItems: 'Maleta',
      note: 'Nota',
      day: 'Dia {{n}}',
      grocery: 'Llista de la compra',
      flight: 'Vol',
      stay: 'Allotjament',
      booking: 'Reserva',
    },
    acceptAll: 'Acceptar totes',
    accept: 'Acceptar',
    discard: 'Descartar',
    sendHint: 'Enter per enviar · Shift+Enter nova línia',
    open: 'Obert',
    closed: 'Tancat',
    willSaveToPlaces: 'Es desa a Places',
    move: 'Moure: {{title}}',
    afterStop: 'després de {{title}}',
    placeholder: {
      places: '"Vull guardar un restaurant al Barri Gòtic"',
      itinerary: '"Afegeix una visita a la Sagrada Família el dia 2"',
      allroutes: '"Fes que el dia 2 sigui una ruta circular" o "Elimina la parada del museu"',
      packing: '"Proposa una llista d\'equipatge" o "Afegeix una secció de platja"',
      tips: '"Dona\'m consells sobre transport i diners"',
      bookings: '"Quant temps tinc entre vols de connexió?"',
      expenses: '"Quant portem gastat en menjar?" o "Qui deu a qui?"',
      general: "\"Planifica'm el dia 3\" o \"Què m'emporto?\"",
    },
    welcome: {
      places: "Hola! Explica'm sobre llocs que vulguis guardar i te'ls proposaré per a la teva llista de Places.",
      itinerary: "Hola! Puc proposar activitats per al teu itinerari o moure-les. Tu decideixes si les acceptes.",
      allroutes: "Hola! Puc reordenar parades per minimitzar desplaçaments, fer rutes circulars, moure activitats entre dies o eliminar parades. Tu decideixes què acceptes.",
      packing: "Hola! Puc proposar-te una llista d'equipatge adaptada al teu viatge. Tu decideixes si l'acceptes.",
      tips: "Hola! Puc proposar-te consells pràctics per a la teva destinació. Tu decideixes si els guardes.",
      bookings: "Hola! Pregunta'm el que vulguis sobre els teus vols i hotels: horaris, connexions, check-in i logística.",
      expenses: "Hola! Pregunta'm sobre les teves despeses, pressupost i saldos: totals per categoria, qui deu a qui o com repartir costos.",
      general: "Hola! Pregunta'm el que vulguis del viatge: llocs, el pla, la maleta, les reserves o les despeses. Tu decideixes què et quedes.",
    },
    // The vocabulary that unlocks the assistant, made visible: an empty
    // input box teaches nobody what it can do.
    suggestions: {
      general: ["Planifica'm el dia 1", "Proposa'm llocs pels meus interessos", "Què m'emporto?"],
      places: ["Proposa'm llocs pels meus interessos", "On menjar bé i barat", "Alguna cosa per fer si plou"],
      itinerary: ["Planifica'm el dia 1", "Aquest dia va molt carregat", "Afegeix un sopar el dia 2"],
      allroutes: ["Optimitza la ruta d'aquest dia", "Fes-la circular", "Mou aquesta parada a un altre dia"],
      packing: ["Què m'emporto?", "Alguna cosa pel temps que farà?"],
      tips: ["Consells per moure'm", "Què hauria de saber abans d'anar-hi?"],
      bookings: ["A quina hora aterro?", "Quant dura la meva escala?"],
      expenses: ["Quant porto gastat?", "Qui deu a qui?", "Vaig dins del pressupost?"],
    },
    category: {
      RESTAURANT: 'Restaurant', CAFE: 'Cafè', ATTRACTION: 'Atracció',
      VIEWPOINT: 'Mirador', NEIGHBORHOOD: 'Barri', PARK: 'Parc',
      SHOP: 'Botiga', EXPERIENCE: 'Experiència', TRANSPORT_HUB: 'Transport',
      BEACH: 'Platja', NATURE: 'Natura', PARKING: 'Pàrquing', OTHER: 'Altre',
    },
    context: { places: 'Llocs', itinerary: 'Itinerari', packing: 'Equipatge', tips: 'Consells', bookings: 'Reserves', expenses: 'Despeses', general: 'Viatge' },
    packingTitle: "Llista d'equipatge",
    packingItems_one: '{{count}} article',
    packingItems_other: '{{count}} articles',
    packingGoToTab: "Obrir la pestanya Maleta",
    budgetTitle: 'Pressupost proposat',
    dayPlanTitle: 'Pla del dia',
    dayNumber: 'Dia {{number}}',
    showPhotos: 'Veure fotos',
    activitiesCount_one: '{{count}} activitat',
    activitiesCount_other: '{{count}} activitats',
    acceptDay: 'Acceptar dia',
    reorderTitle: 'Reordenar',
    applyOrder: 'Aplicar ordre',
    applying: 'Aplicant…',
    review: {
      places: 'Revisar llocs',
      itinerary: 'Revisar activitats afegides',
      packing: 'Revisar maleta',
      tips: 'Revisar consells',
      expenses: 'Revisar despeses',
    },
    tipsTitle: 'Consells',
    tipsCount_one: '{{count}} consell',
    tipsCount_other: '{{count}} consells',
  },
  services: {
    title: 'Serveis del viatge',
    subtitle: "Socis seleccionats per gestionar els detalls avorrits abans de volar. Activa'ls abans de sortir — paga amb Gromly, tingues-ho tot en aquest viatge.",
    partnership: 'Socis de Gromly.',
    partnershipNote: "Guanyem una petita comissió quan compres a través dels nostres enllaços — el preu que pagues és el mateix o inferior amb el nostre codi.",
    connectivity: {
      label: 'Connectivitat',
      eSIM: 'eSIM',
      coverage: 'Cobertura',
      euRoaming: 'Itinerança UE',
      heading: "Connecta't en el moment que aterres",
      body: 'Sense canvi de SIM física. Escaneja el QR abans de volar i el teu telèfon agafa dades en el moment que l\'avió toca terra.',
      editorsPick: 'Elecció de l\'editor',
      from: 'Des de',
      viewPlans: 'Veure plans',
      holafly: {
        subtitle: 'eSIMs amb dades il·limitades',
        description: 'El favorit dels blogs de viatge — activació ràpida, suport en català i anglès, plans de fins a 30 dies per als viatgers tranquils.',
        feature1: 'Plans de dades il·limitades',
        feature2: 'Xat 24/7 en espanyol i anglès',
        feature3: '5, 10, 15 o 30 dies',
        discountNote: '5% de descompte — usa el codi GROMLY en pagar',
        price: '€19',
        priceNote: 'per 5 dies · {{destination}}', priceNoteGeneric: 'per 5 dies',
      },
    },
  },
  notes: {
    loadError: 'Error en carregar les notes', saveError: 'Error en desar la nota',
    createError: 'Error en crear la nota', deleteConfirm: 'Eliminar aquesta nota?',
    deleteError: 'Error en eliminar la nota',
    untitled: 'Sense títol', empty: 'Sense contingut',
    new: 'Nova', emptyState: 'Encara no hi ha notes', createFirst: 'Crea la teva primera nota',
    selectOrCreate: 'Selecciona una nota o crea\'n una de nova',
    allNotes: 'Totes les notes', saved: 'Desat', delete: 'Elimina la nota',
    titleLabel: 'Títol', contentLabel: 'Contingut',
    titlePlaceholder: 'Títol de la nota', contentPlaceholder: 'Escriu aquí les teves notes…',
    uploadError: 'Error en pujar el fitxer', deleteDocError: 'Error en eliminar el fitxer',
    attachments: 'Arxius adjunts', upload: 'Puja',
    dropHere: 'Fes clic per adjuntar fitxers (imatges o PDFs)',
  },
  album: {
    ownPhotos: { title: "Les teves fotos per a l’àlbum", upload: "Puja", hint: "Només al teu àlbum: no van a la Galeria i ningú més del viatge les veu.", tripPhotos: "Fotos del viatge", remove: "Treu aquesta foto del teu àlbum" },
    redoDay: { button: "Refés aquest dia", confirmTitle: "Vols refer aquest dia des del diari?", confirmBody_one: "La seva pàgina es torna a fer amb les fotos i el text del dia. El que hi hagis canviat es perd.", confirmBody_other: "Les seves {{count}} pàgines es tornen a fer amb les fotos i el text del dia. El que hi hagis canviat es perd." },
    wizard: {
      title_create: "Crea el teu àlbum", title_restart: "Torna a començar l’àlbum", steps: "Passos", next: "Següent",
      submit_create: "Crea l’àlbum", submit_restart: "Torna a començar", restartWarning: "Totes les pàgines es tornen a fer des del diari. Les fotos que vas pujar a l’àlbum es queden.",
      format: { step: "Format", title: "Mida i forma", body: "El pots canviar quan vulguis; les pàgines conserven el que tenen." },
      theme: { step: "Estil", title: "L’estil de l’àlbum", body: "Paper i colors. La tipografia i els marcs de foto són a l’editor." },
      density: { step: "Fotos", title: "Quantes fotos per dia?", body: "Les fotos que vas triar al diari hi entren sempre; això només diu quantes més s’hi afegeixen.",
        FEW: "Poques", FEW_hint: "Fins a 2 per dia", NORMAL: "Equilibrat", NORMAL_hint: "Fins a 6 per dia", ALL: "Totes", ALL_hint: "Totes les fotos de cada dia",
        pages_one: "{{count}} pàgina", pages_other: "{{count}} pàgines", tooLong: "Més de {{max}} pàgines: es talla el final" },
      cover: { step: "Portada", title: "La foto de portada", body: "La pots canviar després des de la pàgina de portada." },
    },
    emptyTitle: "El teu àlbum del viatge",
    emptyBody: "El comencem amb el teu diari i les teves fotos, una pàgina per dia. Després tries el disseny, les fotos i els textos. Només el veus tu.",
    create: "Crea el meu àlbum",
    loadError: "No s'ha pogut carregar el teu àlbum", saveError: "No s'ha pogut desar l'àlbum",
    page: "Pàgina {{number}}", template: "Disseny", addPage: "Afegeix una pàgina",
    deletePageN: 'Esborra la pàgina {{number}}',
    deletePage: "Esborra la pàgina", deletePageConfirm: "Vols esborrar aquesta pàgina de l'àlbum?",
    restart: "Torna a començar des del diari",
    templates: { COVER: "Portada", STATS: "En xifres", ONE_PHOTO: "Una foto", TWO_PHOTOS: "Dues fotos", THREE_PHOTOS: "Tres fotos", FOUR_PHOTOS: "Quatre fotos", TEXT_PHOTO: "Text i foto", TRIP_MAP: "Mapa del viatge", DAY_MAP: "Mapa del dia", TEXT_ONLY: "Text", FULL_BLEED: "A sang", TWO_PHOTOS_ASYM: "Gran i petita", THREE_STRIPS: "Tres en franja", FIVE_PHOTOS: "Cinc fotos", SIX_PHOTOS: "Sis fotos", MOSAIC: "Mosaic", TWO_PHOTOS_TEXT: "Dues fotos i text", QUOTE: "Cita", PANORAMA: "Panoràmica", PANORAMA_FRAMED: "Panoràmica amb marges", TRIP_MAP_SPREAD: "Mapa a doble pàgina", COVER_WRAP: "Foto envolvent", COVER_FULL: "Foto a tota pàgina", COVER_TYPE: "Tipogràfica", COVER_FRAMED: "Foto emmarcada", COVER_MOSAIC: "Quatre fotos", COVER_MAP: "Mapa del viatge", COVER_WRAP_FRAMED: "Tapa emmarcada", COVER_WRAP_TWO: "Tapa amb dues fotos" },
    spread: { cover: "Tapa", back: "Contraportada", front: "Portada", wrap: "Tapa sencera", pages: "Pàgines {{pages}}", add: "Afegeix dues pàgines", delete: "Esborra aquestes dues pàgines", deleteN: "Esborra les pàgines {{pages}}", deleteConfirm: "Vols esborrar aquestes dues pàgines de l'àlbum?", swap: "Intercanvia esquerra i dreta", endpaper: "Interior de la tapa: aquí no s'imprimeix res", join: "Uneix-les", joinTitle: "Vols unir les dues pàgines?", joinBody: "Aquest disseny ocupa les dues pàgines. El que no hi càpiga de la pàgina del davant es perdrà." },
    spine: { title: "Llom", placeholder: "Títol al llom", width: "Uns {{mm}} mm d'ample: l'amplada exacta depèn de la impremta.", tooThin: "Uns {{mm}} mm: un títol necessita {{min}} mm. Afegeix pàgines perquè hi càpiga." },
    templateGroups: { label: "Ves als dissenys", covers: "Portades", '1': '1', '2': '2', '3': '3', '4+': '4+', text: "Text", map: "Mapa", spread: "Doble pàgina" },
    templateSections: { 'covers': "Portades", '1': "Una foto", '2': "Dues fotos", '3': "Tres fotos", '4+': "Quatre fotos o més", 'text': "Text", 'map': "Mapes i xifres", 'spread': "Doble pàgina" },
    slot: { PHOTO: "Afegeix una foto", TITLE: "Afegeix un títol", TEXT: "Afegeix text", MAP: "Tria el dia" },
    statsTitle: "El viatge en xifres",
    choosePhoto: "Tria una foto", removePhoto: "Treu la foto", used: "Usada",
    noPhotos: "Aquest viatge encara no té fotos. Puja-les al Diari.",
    selectHint: "Clica un requadre de la pàgina per omplir-lo, o arrossega-hi una foto.",
    chars: "{{count}} / {{max}}", tooLong: "Massa llarg per a aquest requadre: escurça'l o tria un disseny amb més espai.",
    fromDiary: "Insereix del diari", entryOption: "Dia {{number}} · {{text}}",
    dayN: "Dia {{n}}", chooseDay: "Tria el dia",
    tripMapHint: "El mapa del viatge es dibuixa sol amb el teu itinerari: cada dia, del seu color.",
    figures: { legend: "Llegenda", map: "Mapa", world: "Món", country: "País", show: "Mostra", route: "Ruta", stops: "Només punts", outline: "Contorn", outlineShow: "Mostra", outlineHide: "Amaga", kmCaption: "Quilòmetres per carretera" },
    preview: { open: "Fullejar", title: "Previsualització de l'àlbum", prev: "Pàgina anterior", next: "Pàgina següent" },
    style: { typeface: "Tipografia", font: "Lletra", fontOfAlbum: "La de l'àlbum", sizeDown: "Més petita", sizeUp: "Més gran", photoFrame: "Marc de les fotos", textSize: "Mida del text", textAlign: "Alineació", size_S: "Petit", size_M: "Mitjà", size_L: "Gran", align_left: "Esquerra", align_center: "Centre", align_right: "Dreta", theme: "Tema de l'àlbum", pageBackground: "Fons d’aquesta pàgina", fromTheme: "Tema", veil: "Vel", veil_dark: "Vel fosc", veil_light: "Vel clar", removePhoto: "Treu la foto", photoBackground: "Posa una foto de fons" },
    themes: { paper: "Paper", minimal: "Minimal", night: "Nit", sand: "Sorra", sage: "Sàlvia", kraft: "Kraft" },
    backgrounds: { paper: "Paper", white: "Blanc", sand: "Sorra", sage: "Sàlvia", sky: "Cel", blush: "Rosa", kraft: "Kraft", night: "Nit", forest: "Bosc", ink: "Tinta", "paper-dots": "Paper de punts", "paper-grid": "Paper quadriculat", "white-notebook": "Llibreta", "sand-stripes": "Sorra a ratlles", "sage-dots": "Sàlvia de punts", "night-dots": "Nit estrellada" },
    format: { title: "Mida i orientació", "a4-portrait": "A4 vertical", "a5-portrait": "A5 vertical", "a4-landscape": "A4 horitzontal", "a5-landscape": "A5 horitzontal", "square-30": "Quadrat 30", "square-20": "Quadrat 20" },
    fontPairs: { classic: "Clàssica", modern: "Moderna", handwritten: "Manuscrita", typewriter: "Màquina d'escriure", elegant: "Elegant", editorial: "Editorial", rounded: "Arrodonida", poster: "Cartell", script: "Cal·ligrafia", retro: "Retro" },
    photoFrames: { none: "Sense marc", "white-border": "Vora blanca", rounded: "Arrodonit", shadow: "Ombra" },
    tabs: { page: "Pàgina", album: "Àlbum" },
  },
  journal: {
    views: { list: 'Llista', map: 'Mapa' },
    map: { empty: 'Encara no hi ha fotos al mapa', emptyBody: 'Una foto surt aquí quan està vinculada a una parada amb ubicació.', unavailable: 'El mapa no està disponible ara mateix.', unplaced_one: '{{count}} foto sense lloc', unplaced_other: '{{count}} fotos sense lloc' },
    title: 'Diari',
    empty: { title: 'Encara no hi ha res escrit', body: 'Tria un dia i explica què heu fet, amb les vostres fotos.' },
    write: 'Escriure',
    placeholder: 'Què heu fet avui? Què voldreu recordar?',
    choosePhotos_one: '{{count}} foto triada',
    choosePhotos_other: '{{count}} fotos triades',
    addPhotos: 'Afegir fotos',
    noPhotosToChoose: 'Encara no hi ha fotos d’aquest dia. Afegeix-les des d’aquí.',
    sharedLabel: "Ho veuran els seguidors de l'enllaç",
    sharedHint: 'Desmarca-ho perquè aquesta entrada sigui només del grup.',
    groupOnly: 'Només el grup',
    groupOnlyHint: "Els seguidors de l'enllaç no veuen aquesta entrada",
    deleteConfirm: 'Vols esborrar aquesta entrada del diari? Les fotos es queden al viatge.',
    loadError: 'No s’ha pogut carregar el diari',
    saveError: 'No s’ha pogut desar l’entrada',
    deleteError: 'No s’ha pogut esborrar l’entrada',
    previousPhoto: 'Foto anterior',
    nextPhoto: 'Foto següent',
  },
  stats: {
    title: 'Els teus viatges',
    km: 'km',
    days_one: 'dia', days_other: 'dies',
    stops_one: 'parada', stops_other: 'parades',
    photos_one: 'foto', photos_other: 'fotos',
    entries_one: 'entrada', entries_other: 'entrades',
    trips_one: 'viatge', trips_other: 'viatges',
    nights_one: 'nit', nights_other: 'nits',
    countries_one: 'país', countries_other: 'països',
    regions_one: 'continent', regions_other: 'continents',
    mapLabel_one: 'Mapa amb {{count}} país visitat', mapLabel_other: 'Mapa amb {{count}} països visitats',
  },
  gallery: {
    noStop: 'Sense parada', stopLabel: 'Parada',
    title: 'Galeria', upload: 'Puja fotos', uploading: 'Pujant…',
    empty: {
      title: 'Encara no hi ha fotos', dayTitle: 'Encara no hi ha fotos per aquest dia',
      subtitle: 'Arrossega-les aquí o puja-les des del teu dispositiu.',
    },
    allDays: 'Totes',
    dayOption: 'Dia {{number}}', unassignedDay: 'Sense dia', uploadedBy: 'Per {{name}}',
    download: 'Descarrega l’original', delete: 'Elimina la foto',
    deleteConfirm: 'Vols eliminar aquesta foto? No es pot desfer.',
    loadError: 'Error en carregar les fotos', uploadError: 'Error en pujar {{name}}',
    deleteError: 'Error en eliminar la foto', moveError: 'Error en moure la foto',
    selection: { moveToDay: "Moure a un dia", searchStop: "Cerca una parada", noStopMatch: "Cap parada coincideix", count_one: "{{count}} seleccionada", count_other: "{{count}} seleccionades", all: "Seleccionar-ho tot", none: "Treure la selecció", selectPhoto: "Seleccionar la foto", unselectPhoto: "Treure la foto de la selecció", place: "Assignar lloc", stopHint: "Les fotos d'un altre dia passen al dia del lloc que triïs.", deleteConfirm_one: "Eliminar aquesta foto? No es pot desfer.", deleteConfirm_other: "Eliminar {{count}} fotos? No es pot desfer.", updated_one: "{{count}} foto actualitzada", updated_other: "{{count}} fotos actualitzades", updateFailed: "No s'han pogut canviar {{count}} de {{total}} fotos", deleted_one: "{{count}} foto eliminada", deleted_other: "{{count}} fotos eliminades", deleteFailed: "No s'han pogut eliminar {{count}} de {{total}} fotos" },
    // ADR-0058
    suggest: { button: "Suggerir llocs", hint: "La IA mira les fotos i suggereix la parada del viatge on es va fer cadascuna. 1 crèdit d'IA cada 10 fotos.", title: "Llocs suggerits per la IA", looking: "Mirant {{count}} fotos…", summary: "Ha trobat parada per a {{found}} de {{total}} fotos. Marca les que estiguin bé.", none: "Sense suggeriment", unsure: "No n'està segura", alreadyThere: "ja hi és", apply: "Aplicar ({{count}})", privacy: "Les fotos s'envien a OpenAI per analitzar-les.", failed: "No s'han pogut suggerir llocs. Torna-ho a provar." },
    placedByDate_one: '{{count}} foto col·locada al seu dia segons la data en què es va fer', placedByDate_other: '{{count}} fotos col·locades al seu dia segons la data en què es van fer',
  },
  billing: {
    credits: { label: 'Crèdits de viatge' },
    paywall: {
      title: "Fes-te PRO",
      description: "Has fet servir els viatges gratuïts. PRO és un pla anual amb viatges il·limitats i fins a 500 peticions d'IA al mes.",
      perks: ["Viatges il·limitats", "500 peticions d'IA al mes", "Tot el que ja fas servir, sense límits"],
      cta: "Fes-te PRO",
      error: "Error en iniciar el pagament. Torna-ho a intentar.",
    },
    aiPaywall: {
      title: "Sense peticions d'IA",
      description: "Has fet servir les peticions d'IA gratuïtes. PRO n'inclou 500 al mes.",
      cta: "Fes-te PRO",
      error: "Error en iniciar el pagament. Torna-ho a intentar.",
    },
    payment: {
      success: "Benvingut a PRO! Pot trigar uns segons a aparèixer.",
      cancelled: "Pagament cancel·lat.",
    },
  },
  landing: {
    nav: {
      features: 'Funcions',
      ai: 'IA',
      community: 'Comunitat',
      marketplace: 'Marketplace',
      signIn: 'Iniciar sessió',
      getStarted: 'Començar',
    },
    hero: {
      eyebrow: 'On comença cada viatge',
      headline1: 'Planifica cada',
      headline2: 'aventura.',
      subheading: "Itineraris, despeses, reserves i llocs per visitar — tot en un mateix lloc, compartit només amb qui viatja amb tu.",
      pills: {
        itinerary: 'Itinerari',
        expenses: 'Despeses',
        aiRoutes: 'Rutes IA',
        plane: 'Vol',
        bookings: 'Reserves',
        collaborative: 'Col·laboratiu',
      },
      ctaPrimary: 'Començar gratis',
      ctaSecondary: 'Iniciar sessió',
    },
    mock: {
      nightsLabel: '{{range}} · {{count}} NITS',
      tripTitle: 'Estiu a Islàndia',
      active: 'ACTIU',
      moreCount: '+{{count}} més',
      totalSpent: 'GASTAT',
      ofBudget: 'de {{amount}} pressupost',
      activities: 'ACTIVITATS',
      acrossDays: 'en {{count}} dies',
      dayHeader: 'DIA {{day}} — {{place}}',
      routeOptimized: 'Ruta optimitzada',
      splitSettled: 'Divisió saldada · {{count}}p',
      aiOptimized: 'IA Optimitzat · Dia {{day}}',
      whoOwesWhom: 'QUI DEU A QUI',
      settle: 'Saldar',
      settledCount: 'SALDATS · {{count}}',
    },
    ticker: {
      label: 'Viatges planificats a',
    },
    features: {
      eyebrow: 'Tot el que necessites',
      headlineLine1: 'Un sol lloc per a cada part',
      headlineLine2Pre: 'del',
      headlineLine2Highlight: 'viatge.',
      description: 'Pensat per a viatges reals, no idealitzats. Controla des del vol fins a la reserva del restaurant.',
      cards: {
        itinerary: {
          title: 'Itinerari dia a dia',
          desc: 'Crea un itinerari arrossegable amb activitats, horaris i categories. Comparteix-lo en directe amb tot el grup.',
        },
        expenses: {
          title: 'Despeses i divisions',
          desc: "Registra cada despesa, divideix els costos entre el grup i mira exactament qui deu a qui amb un toc per saldar.",
        },
        ai: {
          title: 'Optimitzador de rutes IA',
          desc: "Digues-li a la IA les teves preferències i reordena les parades per minimitzar el temps de viatge. Accepta llenguatge natural.",
        },
        bookings: {
          title: 'Centre de reserves',
          desc: 'Gestiona vols, hotels, transport i esdeveniments en un sol lloc. Adjunta PDFs, números de referència i recordatoris.',
        },
        map: {
          title: 'Mapa i llocs',
          desc: 'Descobreix llocs, marca\'ls com a visitats i afegeix-los al teu itinerari directament des de la vista del mapa.',
        },
        collaborative: {
          title: 'Planificació col·laborativa',
          desc: 'Convida el teu grup, assigna rols i planifiqueu junts. Tothom veu els canvis en temps real, sense fulls de càlcul.',
        },
      },
    },
    ai: {
      eyebrow: 'Impulsat per IA',
      headline1: 'El teu optimitzador',
      headline2: 'de viatges personal.',
      description: "Explica-li a la IA les teves preferències en llenguatge natural — horaris de menjar, llocs imprescindibles, com t'agrada viatjar — i reconstrueix el teu dia en segons.",
      chips: {
        route: 'Optimització de ruta',
        hints: 'Llenguatge natural',
        mode: 'Mode de transport',
        grouping: 'Agrupació per zones',
      },
      cta: 'Prova-ho gratis',
    },
    groups: {
      eyebrow: 'Pensat per a grups',
      headline1: 'Planifiqueu junts,',
      headline2: 'no per separat.',
      description: "Convida el teu grup, assigna editors o espectadors, i divideix cada despesa automàticament. Un toc per saldar — sense missatges incòmodes per WhatsApp.",
      features: {
        invite: 'Convidar amb enllaç, gestionar rols',
        split: 'Càlcul automàtic de divisions',
        settle: 'Saldar deutes amb un toc',
        sync: 'Sincronització en temps real',
      },
      morePlanning: 'planificant junts',
      morePrefix: '+{{count}} més',
    },
    marketplace: {
      eyebrow: 'Marketplace de la comunitat',
      headline1: 'Descobreix viatges',
      headline2: 'de la comunitat.',
      description: 'Explora itineraris públics de viatgers de tot el món. Clona qualsevol viatge amb un clic i adapta\'l a les teves dates, grup i pressupost — sense començar de zero.',
      features: {
        browse: 'Explora itineraris públics seleccionats',
        clone: 'Clona i personalitza qualsevol viatge',
        ratings: 'Valoracions i opinions de la comunitat',
        follow: 'Segueix viatgers que admires',
      },
      cta: 'Explorar la comunitat',
      cloneTrip: 'Clonar viatge',
      nights: '{{country}} · {{count}} nits',
      tripTags: {
        nature: 'Natura',
        culture: 'Cultura',
        adventure: 'Aventura',
        hiking: 'Senderisme',
        beach: 'Platja',
        food: 'Gastronomia',
        souks: 'Zocs',
      },
    },
    bottomCta: {
      eyebrow: 'Comença gratis',
      headline1: 'La teva propera aventura',
      headline2: 'comença aquí.',
      description: 'Uneix-te a milers de viatgers que planifiquen millor, divideixen despeses justes i guarden millors records.',
      button: 'Crear compte gratis',
      haveAccount: 'Ja tinc compte',
      fineprint: 'No cal targeta · Pla gratuït per sempre disponible',
    },
    footer: {
      privacy: 'Privacitat',
      terms: 'Termes',
      legal: 'Avís legal',
      copyright: '© MMXXVI GROMLY · VESTIGI PLATFORM, S.L.',
    },
  },
  explore: {
    toast: {
      loadFailed: 'Error en carregar els viatges',
      tripNotFound: 'Viatge no trobat',
      ratingFailed: "Error en valorar",
      followFailed: "No s'ha pogut actualitzar el seguiment",
      cloned: 'Viatge afegit al teu compte!',
      cloneFailed: 'Error en clonar',
      insufficientCredits: "No et queden crèdits de viatge. Millora el pla per obtenir-ne més.",
    },
    breadcrumb: 'Comunitat · Plantilles',
    heading: 'Explorar viatges',
    searchPlaceholder: 'Destinació o viatge…',
    feed: { all: 'Tots', following: 'Seguint' },
    filters: {
      days: 'Dies', any: 'Qualsevol', clear: 'Netejar',
      button: 'Filtres',
      title: 'Filtres',
      sortBy: 'Ordenar per',
      destination: 'Destinació',
      destinationPlaceholder: 'p. ex. París, Itàlia…',
      nights: 'Nits',
      budgetPerDay: 'Pressupost per dia',
      budgetHint: 'Calculat a partir de la despesa real dividida per la durada del viatge.',
      activities: 'Tipus d\'activitat',
      month: 'Mes del viatge',
      anyMonth: 'Qualsevol mes',
      participants: 'Mida del grup',
      min: 'Mín',
      max: 'Màx',
      apply: 'Aplicar',
      reset: 'Reiniciar',
      clearAll: 'Treu-ho tot',
      activityType: {
        RESTAURANT: 'Restaurant',
        CAFE: 'Cafè',
        MONUMENT: 'Monument',
        VIEWPOINT: 'Mirador',
        NEIGHBORHOOD: 'Barri',
        PARK: 'Parc',
        SHOP: 'Botiga',
        EXPERIENCE: 'Experiència',
        TRANSPORT: 'Transport',
        PARKING: 'Pàrquing',
        BEACH: 'Platja',
        NATURE: 'Natura',
        ACCOMMODATION: 'Allotjament',
        OTHER: 'Altre',
      },
    },
    sort: { recent: 'Més recents', topRated: 'Millor valorats', mostUsed: 'Més usats' },
    results: {
      trips_one: '{{count}} viatge',
      trips_other: '{{count}} viatges',
      days_one: '{{count}} dia',
      days_other: '{{count}} dies',
    },
    empty: {
      title: "No s'han trobat viatges",
      body: 'Prova una altra cerca o filtre.',
    },
    loadMore: 'Carregar més',
    detail: {
      backToExplore: 'Explorar',
      mapUnavailable: 'Mapa no disponible',
      allPlaces: 'Tots els llocs',
      dayByDay: 'Dia a dia',
      dayLabel: 'Dia {{n}}',
      stops_one: '{{count}} parada',
      stops_other: '{{count}} parades',
      calculatingRoute: 'Calculant ruta…',
      noStopsToday: 'No hi ha parades amb ubicacions aquest dia.',
      stopFallback: 'Parada {{n}}',
      openInMaps: 'Obrir al mapa',
      noItinerary: 'Sense itinerari planejat.',
      activities_one: '{{count}} activitat',
      activities_other: '{{count}} activitats',
      noActivities: 'Sense activitats planificades',
      noPlaces: 'Sense llocs llistats.',
      noTips: 'Sense tips compartits.',
      actualSpend: 'Despesa real',
      tripNotes: 'Notes del viatge',
      useAsTemplate: 'Usar com a plantilla',
      used: 'Usat',
      times_one: '{{count}} vegada',
      times_other: '{{count}} vegades',
      communityRating: 'Valoració de la comunitat',
      noRatingsYet: 'Sense valoracions encara',
      ratings_one: '{{count}} valoració',
      ratings_other: '{{count}} valoracions',
      rateThisTrip: 'Valora aquest viatge',
      youRated_one: "Has valorat amb {{count}} estrella",
      youRated_other: 'Has valorat amb {{count}} estrelles',
      tripDetails: 'Detalls del viatge',
      stats: {
        destination: 'Destinació',
        dates: 'Dates',
        duration: 'Durada',
        people: 'Persones',
        activities: 'Activitats',
        nights_one: '{{count}} nit',
        nights_other: '{{count}} nits',
      },
      author: 'Autor',
      publishedAgo: 'Publicat fa {{time}}',
      follow: 'Seguir',
      following: 'Seguint',
      travelMode: {
        WALKING: 'Caminar',
        DRIVING: 'Cotxe',
        BICYCLING: 'Bici',
        TRANSIT: 'Transport',
      },
      tabs: {
        itinerary: 'Itinerari',
        places: 'Llocs',
        map: 'Mapa',
        tips: 'Tips i info',
        expenses: 'Pressupost',
        notes: 'Notes',
      },
    },
    clone: {
      title: 'Usar com a plantilla',
      tripName: 'Nom del viatge',
      whenLabel: 'Quan vols anar-hi?',
      tripEnds: 'Acaba',
      keepOriginalDates: "Deixa-ho buit per mantenir les dates originals.",
      addToMyTrips: 'Afegir als meus viatges',
      daysLabel: 'Dies a copiar',
      selectAll: 'Tots',
      clearAll: 'Cap',
      selectAtLeastOne: 'Selecciona almenys un dia',
      untitledDay: 'Dia sense títol',
      activitiesCount_one: '{{count}} activitat',
      activitiesCount_other: '{{count}} activitats',
      summaryDays_one: '{{count}} dia',
      summaryDays_other: '{{count}} dies',
      summaryNights_one: '{{count}} nit',
      summaryNights_other: '{{count}} nits',
    },
  },
  pdf: {
    nights_one: '{{count}} nit', nights_other: '{{count}} nits',
    coverLabel: 'Itinerari de viatge', travellers: 'Viatgers', budget: 'Pressupost', notes: 'Notes',
    generatedOn: 'Generat el {{date}}',
    itinerary: 'Itinerari', placesToVisit: 'Llocs per visitar', bookings: 'Reserves',
    expenses: 'Despeses', checklists: 'Checklists', tips: 'Consells',
    meals: 'Menjars', grocery: 'Llista de la compra',
    flights: 'Vols', hotels: 'Hotels', otherReservations: 'Altres reserves',
    balances: 'Balanços',
    category: 'Categoria', name: 'Nom', zone: 'Zona', address: 'Adreça', visited: 'Visitat',
    direction: 'Direcció', route: 'Ruta', departure: 'Sortida', arrival: 'Arribada',
    flight: 'Vol', ref: 'Ref', outbound: 'Anada', return: 'Tornada',
    type: 'Tipus', title: 'Títol', date: 'Data', description: 'Descripció',
    paidBy: 'Pagat per', amount: 'Import', owes: 'Deu',
    totalSpent: 'Total gastat', perPerson: 'Per persona', checkIn: 'Entrada', checkOut: 'Sortida',
  },
  essentials: {
    heading: "Essencials de {{country}}",
    currency: "Moneda", language: "Idioma", capital: "Capital", callingCode: "Prefix telefònic",
    plug: "Corrent", plugType: "Tipus", driving: "Conducció", tapWater: "Aigua de l'aixeta", emergency: "Emergències",
    emergencyGeneral: "general", emergencyPolice: "policia", emergencyAmbulance: "ambulància", emergencyFire: "bombers",
    drive: { left: "Per l'esquerra", right: "Per la dreta" },
    water: { safe: "Potable", caution: "Amb precaució", unsafe: "Beu embotellada" },
    advisory: { normal: "Sense avisos importants", see_advisory: "Consulta l'avís de viatge", avoid_essential: "Evita viatges no essencials", avoid_all: "Evita qualsevol viatge" },
    practicalDisclaimer: "Informació orientativa — pot variar segons la zona.",
    visa: {
      visa_free: "Sense visat", visa_on_arrival: "Visat a l'arribada", e_visa: "e-Visat", eta: "Autorització de viatge", visa_required: "Visat obligatori", no_admission: "Entrada no permesa",
      upToDays_one: "fins a {{count}} dia", upToDays_other: "fins a {{count}} dies",
    },
    requirements: {
      heading: "Requisits d'entrada", forNationality: "Per a passaport de {{nationality}}",
      forCountry: "Per entrar a {{country}}",
      visa: "Visat", passport: "Passaport", vaccines: "Vacunes", unknown: "No disponible",
      passportValidity_one: "Vàlid {{count}}+ mes després de l'estada", passportValidity_other: "Vàlid {{count}}+ mesos després de l'estada", passportValidZero: "Sense validesa extra després de l'estada",
      noVaccines: "No calen vacunes per entrar", mandatory: "Obligatòria",
      checkedOn: "Consultat {{date}}", verifyOfficial: "Verifica oficialment",
      missingPrompt: "Afegeix la teva nacionalitat per veure requisits de visat i vacunes", empty: "Encara no hi ha requisits per mostrar",
      disclaimer: "Informació orientativa, no oficial. Les normes d'entrada i sanitàries canvien: confirma sempre amb el consolat del destí o una font oficial abans de viatjar.",
    },
  },
  redeemCode: {
    entry: "Tinc un codi",
    title: "Obre el teu viatge",
    body: "La teva agència de viatges t'ha donat un codi de 8 caràcters. Funciona amb el correu que li vas donar: {{email}}.",
    label: "Codi del viatge",
    submit: "Obre el meu viatge",
    joined: "El teu viatge ja està a punt",
    errors: {
      notFound: "Aquest codi no correspon a cap invitació per a {{email}}. Revisa'l, i comprova que has entrat amb el correu que vas donar a la teva agència.",
      emailNotVerified: "Primer verifica el correu: et vam enviar un enllaç quan et vas registrar.",
      expired: "Aquest codi ha caducat. Demana'n un de nou a la teva agència.",
      revoked: "La teva agència ha anul·lat aquest codi. Demana-li'n un de nou.",
      tooMany: "Massa intents. Torna-ho a provar d'aquí a una hora.",
      generic: "No hem pogut obrir el viatge. Torna-ho a provar.",
    },
  },
  agency: {
    card: {
      preparedBy: "Preparat per",
      emergency: "Telèfon d'emergència",
      email: "Correu",
    },
    managesTravellers: "En aquest viatge els viatgers els gestiona la teva agència. Demana-li que hi afegeixi qui falti.",
    panel: {
      tabs: {
        current: "Viatges",
        past: "Passats",
        templates: "Circuits",
        clients: "Clients",
        team: "Equip",
        settings: "Configuració",
      },
      currentTab: "En curs",
      newTrip: "Nou viatge",
      newTemplate: "Nou circuit",
      newDeparture: "Nova sortida",
      duplicate: "Duplicar",
      duplicateName: "{{name}} (còpia)",
      duplicateFailed: "No s'ha pogut duplicar el circuit",
      days_one: "{{count}} dia",
      days_other: "{{count}} dies",
      nights_one: "{{count}} nit",
      nights_other: "{{count}} nits",
      addDescription: "Afegeix una descripció",
      descriptionPlaceholder: "Descriu el circuit: què inclou, per a qui és…",
      descriptionFailed: "No s'ha pogut desar la descripció",
      empty: {
        currentTitle: "No hi ha viatges en curs",
        currentBody: "Crea un viatge, o una sortida d'un dels teus circuits.",
        pastTitle: "Encara no hi ha viatges passats",
        pastBody: "Els viatges passen aquí una setmana després d'acabar. Des de llavors són dels teus clients.",
        templatesTitle: "Encara no hi ha circuits",
        templatesBody: "Un circuit és un viatge que vens una vegada i una altra. Prepara'l un cop i crea una sortida per a cada data.",
      },
      managedUntil: "El gestiones fins al {{date}}",
      handedOver: "Del teu client des del {{date}}",
      open: "Obre",
      lead: "Viatger principal",
      status: {
        NOT_INVITED: "Sense invitació",
        INVITED: "Convidat",
        ACTIVATED: "Activat",
        JOINED: "Unit",
      },
      copyCode: "Copia el codi",
      codeCopied: "Codi copiat",
      activations: {
        title: "Viatgers activats",
        count_one: "{{count}} viatger activat",
        count_other: "{{count}} viatgers activats",
        empty: "Ningú no s'ha activat aquest mes.",
        month: "Mes",
      },
      usage: {
        title: "Aquest mes",
        maps: "Maps: {{used}} de {{cap}}",
        ai: "IA: {{used}} de {{cap}} peticions",
      },
      loadFailed: "No s'ha pogut carregar l'agència",
    },
    home: {
      tagline: "El que tens entre mans avui.",
      stats: {
        ongoing: "En curs",
        leavingSoon: "Surten en els propers 7 dies",
        pending: "Viatgers sense activar",
        activated: "Activats aquest mes",
      },
      sections: {
        attention: "Requereix atenció",
        ongoing: "En curs",
        upcoming: "Properes sortides",
        activations: "Últimes activacions",
        circuits: "Circuits",
      },
      attentionHint: "Encara no han bescanviat el codi, i el viatge és en curs o surt en menys de dues setmanes.",
      allClear: "Hi són tots. Ara mateix res no et necessita.",
      leavesToday: "Surt avui",
      leavesTomorrow: "Surt demà",
      leavesIn_one: "Surt d'aquí a {{count}} dia",
      leavesIn_other: "Surt d'aquí a {{count}} dies",
      dayOf: "Dia {{day}} de {{total}}",
      activatedOf: "{{done}}/{{total}} activats",
      noUpcoming: "No hi ha sortides programades.",
      noActivations: "Aquest mes encara no s'ha activat ningú.",
      allTrips: "Tots els viatges",
      seeAll: "Veure-les totes",
      emptyTitle: "La teva agència està a punt",
      emptyBody: "Crea el teu primer viatge, o un circuit que vendràs una vegada i una altra.",
    },
    departure: {
      title: "Nova sortida: {{name}}",
      name: "Nom del viatge",
      startDate: "Data d'inici",
      travellers: "Viatgers",
      leadHint: "El primer és el propietari del viatge quan bescanvia el seu codi.",
      travellerName: "Nom",
      travellerEmail: "Correu (per enviar-li el codi)",
      addTraveller: "Afegeix viatger",
      removeTraveller: "Treu",
      submit: "Crea la sortida",
      created: "Sortida creada",
      invitesFailed_one: "{{count}} invitació no s'ha pogut enviar",
      invitesFailed_other: "{{count}} invitacions no s'han pogut enviar",
      failed: "No s'ha pogut crear la sortida",
    },
    settings: {
      brandTitle: "El que veuen els teus viatgers",
      brandHint: "Es mostra dins del viatge mentre el gestiones.",
      name: "Nom de l'agència",
      emergencyPhone: "Telèfon d'emergència",
      contactEmail: "Correu de contacte",
      logo: "Logo",
      uploadLogo: "Puja el logo",
      removeLogo: "Treu el logo",
      save: "Desa",
      saved: "Desat",
      saveFailed: "No s'ha pogut desar",
    },
    clients: {
      title: "Clients",
      new: "Nou client",
      edit: "Edita el client",
      search: "Cerca per nom o correu",
      saveFailed: "No s'ha pogut desar el client",
      loadFailed: "No s'ha pogut carregar el client",
      deleteFailed: "No s'ha pogut esborrar el client",
      form: {
        name: "Nom",
        email: "Correu",
        phone: "Telèfon",
        birthDate: "Data de naixement",
        notes: "Notes",
        emailInvalid: "Aquest correu no sembla correcte",
        emailHint: "Sense correu viatja igual, però no rep codi: algú del grup li pot compartir el viatge.",
      },
      picker: {
        noEmail: "Sense correu — no rebrà codi",
        makeLead: "Fes-lo viatger principal",
        remove: "Treu",
        search: "Cerca als teus clients",
        noMatch: "Cap client coincideix.",
        emptyBook: "Encara no tens clients: dona d'alta el primer.",
        createNamed: "Nou client «{{name}}»",
      },
      bornOn: "Nascut el {{date}}",
      hasAccount: "Té compte",
      trips: "Viatges amb vosaltres",
      noTrips: "Encara cap viatge.",
      deleteTitle: "Vols esborrar {{name}}?",
      deleteBody: "Surt de la teva cartera de clients. Els seus viatges continuen sent seus.",
      noMatchTitle: "Cap client coincideix",
      emptyTitle: "Encara no tens clients",
      emptyBody: "Cada viatger que afegeixes a un viatge queda aquí, perquè la propera vegada només l'hagis de triar.",
      noContact: "Sense dades de contacte",
      tripCount_one: "{{count}} viatge",
      tripCount_other: "{{count}} viatges",
    },
    team: {
      loadFailed: "No s'ha pogut carregar l'equip",
      lastAdmin: "L'agència necessita almenys un admin.",
      failed: "Alguna cosa ha fallat",
      invited: "Invitació enviada a {{email}}",
      alreadyMember: "Ja és a l'equip.",
      inviteTitle: "Convida a l'equip",
      inviteHint: "Rebrà un correu i entrarà quan accepti amb aquesta adreça. Els seus viatges personals continuen sent seus.",
      emailPlaceholder: "companya@agencia.com",
      role: "Rol",
      roles: {
        ADMIN: "Admin",
        AGENT: "Agent",
      },
      invite: "Convida",
      you: "(tu)",
      remove: "Treu {{name}}",
      pending: "Pendent",
      revoke: "Cancel·la la invitació",
      removeTitle: "Vols treure {{name}} de l'equip?",
      removeBody: "Perd l'accés als viatges i clients de l'agència. Els seus viatges personals continuen sent seus.",
      removeConfirm: "Treu",
    },
    invite: {
      gone: {
        expired: "Aquesta invitació ha caducat",
        used: "Aquesta invitació ja s'ha fet servir",
        notFound: "Aquesta invitació no existeix",
      },
      goneBody: "Demana a l'agència que te n'enviï una altra.",
      goHome: "Ves al meu inici",
      accepted: "Benvingut a {{agency}}",
      verifyFirst: "Verifica primer el teu correu i després accepta.",
      failed: "No s'ha pogut acceptar la invitació",
      eyebrow: "Invitació",
      title: "Uneix-te a {{agency}}",
      body: {
        ADMIN: "Com a admin: prepares els viatges dels seus clients i gestiones l'equip.",
        AGENT: "Prepararàs els viatges dels seus clients.",
      },
      keepTrips: "Els teus viatges personals continuen sent teus: canvies entre ells i l'agència des del menú del teu perfil.",
      accept: "Accepta i uneix-t'hi",
      wrongEmail: "Aquesta invitació és per a {{invited}} i has entrat com a {{current}}. Entra amb aquest correu per acceptar-la.",
    },
    wizard: {
      ask: "Per a qui és aquest viatge?",
      hint: "Tria'ls dels teus clients o dona'n d'alta un de nou. El primer és el viatger principal: el viatge és seu quan bescanvia el codi.",
      clientsCount_one: "{{count}} client",
      clientsCount_other: "{{count}} clients",
    },
  },
  admin: {
    loadFailed: "No s'ha pogut carregar. Torna-ho a provar.",
    acting: { inside: "Ets dins de {{agency}} com a Gromly", leave: "Surt", enter: "Entra" },
    usage: {
      subtitle: "Del {{from}} al {{to}}, comparat amb del {{prevFrom}} al {{prevTo}}.", subtitleLoading: "Carregant…",
      rangeLabel: "Període", from: "Des de", to: "Fins a",
      range: { month: "Aquest mes", lastMonth: "Mes passat", "7d": "7 dies", "30d": "30 dies", "90d": "90 dies", "12m": "12 mesos", custom: "Personalitzat" },
      segmentLabel: "De qui és la despesa", segment: { all: "Tot", personal: "Viatges personals", agency: "Viatges d'agència" },
      clearFilter: "Deixar de filtrar per {{name}}", deletedUser: "Compte eliminat", deletedTrip: "Viatge eliminat",
      vsPrevious: "Respecte al període anterior",
      tiles: { total: "Total", maps: "Maps", ai: "IA", users: "Usuaris amb despesa", outside: "Fora de viatges", projection: "Projecció del mes" },
      calls_one: "{{count}} crida", calls_other: "{{count}} crides",
      aiDetail: "{{calls}} crides · {{credits}} crèdits", perUser: "{{amount}} per usuari",
      outsideDetail: "Cerques i l'assistent, abans que existeixi el viatge", projectionDetail: "Al ritme d'aquest mes",
      trend: "Despesa del període", trendLabel: "Despesa de Maps i IA del període",
      byMaps: "Maps per servei", byAi: "IA per funció", byModel: "IA per model",
      topUsers: "Qui gasta més", topTrips: "Viatges que costen més", noAgencySpend: "Cap agència ha gastat en aquest període",
      split: "Maps {{maps}} · IA {{ai}}", mapsCap: "Topall de Maps {{amount}}/mes",
      empty: "Sense despesa en aquest període",
      footnote: "Registrat des del 27 de juliol de 2026. La despesa dins d'un viatge d'agència compta per a l'agència (ADR-0034); la de fora de viatges, com a personal.",
      maps: { placeResolution: "Trobar llocs", placeDetails: "Fitxes de llocs", photos: "Fotos", search: "Cerca i autocompletar", routes: "Rutes", mapLoads: "Càrregues de mapa", other: "Altres" },
      ai: { chatQuestion: "Xat · preguntes", chatAction: "Xat · accions", chatTriage: "Xat · triatge", chat: "Xat · altres", import: "Importar documents", extraction: "Llegir bitllets i tiquets", wizard: "Assistent de nou viatge", essentials: "Informació del país" },
    },
    nav: { overview: "Resum", users: "Usuaris", agencies: "Agències", usage: "Ús i costos" },
    overview: {
      title: "Gromly d'un cop d'ull", subtitle: "Qui l'utilitza, d'on ve i quant costa.",
      signups: "Altes per mes", trips: "Viatges creats per mes", seeUsers: "Veure usuaris",
      personalTrips: "Personals", agencyTrips: "Amb agència", manageAgencies: "Gestionar agències",
      footnote: "Els usuaris actius es compten des que es va començar a registrar l'activitat. Els viatges de demo i les plantilles d'agència no compten com a viatges.",
      chartLabel: "Gràfic mensual: {{series}}",
      activations_one: "{{count}} viatger activat aquest mes", activations_other: "{{count}} viatgers activats aquest mes",
      maps: "Maps aquest mes", ai: "Peticions d'IA",
      stats: {
        users: "Usuaris", usersDetail_one: "{{count}} de nou aquest mes", usersDetail_other: "{{count}} de nous aquest mes",
        active: "Actius (30 dies)", activeDetail_one: "{{count}} els últims 7 dies", activeDetail_other: "{{count}} els últims 7 dies",
        pro: "PRO", proDetail_one: "{{count}} de regal", proDetail_other: "{{count}} de regal",
        fromAgencies: "Arribats per agències", fromAgenciesDetail_one: "{{count}} ha creat després un viatge propi", fromAgenciesDetail_other: "{{count}} han creat després un viatge propi",
        trips: "Viatges", tripsDetail_one: "{{count}} aquest mes · {{agency}} amb agència", tripsDetail_other: "{{count}} aquest mes · {{agency}} amb agència",
        cost: "Cost del mes", costDetail: "Mes passat: {{amount}}",
      },
    },
    users: {
      total_one: "{{count}} usuari", total_other: "{{count}} usuaris",
      search: "Cerca per nom, usuari o correu", originLabel: "Origen", anyOrigin: "Qualsevol origen", tagLabel: "Tipus", anyTag: "Qualsevol tipus",
      empty: "Cap usuari coincideix amb aquests filtres", pagination: "Pàgines", prev: "Pàgina anterior", next: "Pàgina següent", pageOf: "Pàgina {{page}} de {{pages}}",
      origin: { direct: "Directe", agency: "Per agència" },
      filter: { staff: "Personal d'agència", traveller: "Viatgers d'agència", pro: "PRO", admin: "Administradors" },
      tags: { staffOf: "Personal · {{agency}}", travellerOf: "Viatger · {{agency}}", pro: "PRO", proGift: "PRO regalat", admin: "Admin" },
      cols: { user: "Usuari", tags: "Perfil", trips: "Viatges", joined: "Alta", lastActive: "Última activitat" },
    },
    user: {
      ownTrips: "Viatges propis", agencyTrips: "Viatges amb agència", usageMonth: "Ús aquest mes", usageAll: "Ús total",
      aiCredits_one: "{{count}} crèdit d'IA", aiCredits_other: "{{count}} crèdits d'IA",
      credits: "Crèdits restants", creditsValue: "{{ai}} IA · {{trips}} viatges",
      pro: {
        title: "PRO", paid: "Paga PRO ({{source}}) fins al {{date}}. Un PRO pagat no es pot regalar a sobre ni retirar des d'aquí.",
        giftUntil: "PRO regalat fins al {{date}}.", none: "No és PRO. Li pots regalar fins a una data.",
        presets: "Durada", months_one: "{{count}} mes", months_other: "{{count}} mesos",
        extendMonths_one: "+{{count}} mes", extendMonths_other: "+{{count}} mesos",
        until: "Fins al", grant: "Regalar PRO", update: "Canviar la data", revoke: "Retirar el regal",
        revokeTitle: "Retirar el PRO regalat?", revokeBody: "Deixa de ser PRO ara mateix. No s'esborra res del que ha creat.",
        granted: "PRO regalat", revoked: "Regal retirat", alreadyPaid: "Aquest usuari ja paga PRO", failed: "No s'ha pogut desar el canvi",
        historyGranted: "{{date}} · regalat per {{actor}}", historyRevoked: "{{date}} · retirat per {{actor}}", unknownActor: "un admin eliminat",
        source: { STRIPE: "web", APP_STORE: "App Store", PLAY_STORE: "Google Play" },
      },
    },
  },
  adminAgencies: {
    title: "Agències",
    name: "Nom",
    contactEmail: "Correu de contacte",
    members: "Personal",
    addMember: "Convida",
    memberEmail: "Correu de l'admin de l'agència",
    removeMember: "Treu",
    mapsCap: "Topall de Maps (€/mes)",
    aiCap: "Peticions d’IA / mes",
    activations_one: "{{count}} activat aquest mes",
    activations_other: "{{count}} activats aquest mes",
    downloadCsv: "CSV d'activats",
    save: "Desa",
    saved: "Desat",
    empty: "Encara no hi ha agències.",
    invited: "Invitació enviada a {{email}}",
    alreadyMember: "Ja és a l'equip.",
    failed: "Alguna cosa ha fallat",
    subtitle: "Les agències es donen d'alta a mà. El seu personal necessita abans un compte a Gromly.",
    newTitle: "Nova agència",
    staffEmpty: "Encara sense personal: afegeix el correu d'algú amb compte a Gromly.",
    limitsTitle: "Topalls mensuals",
    limitsHint: "El que poden gastar en Maps i IA tots els viatges de l'agència junts.",
    billingTitle: "Factura",
    billingHint: "Una línia per viatger activat al mes.",
    statMaps: "Maps aquest mes",
    statAi: "IA aquest mes",
    statActivations: "Activats aquest mes",
    of: "{{used}} de {{cap}}",
    logoHint: "Fes clic al logo per canviar-lo",
  },
} as const;

export default ca;
